import Main from '@/components/main'
import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'-'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

let defaults = [
  {
    path: '/admin/login',
    name: 'login',
    meta: {
      title: '登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login')
  },
  {
    path: '/admin',
    name: '-home',
    redirect: {
      name: 'login',
    },
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: '/admin/home',
        name: 'home',
        meta: {
          title: '首页',
          notCache: true
          // access: ['home-statis'],
        },
        component: () => import('@/view/home/default')
      },
      // {
      //   path: '/admin/statis',
      //   name: 'statis',
      //   meta: {
      //     title: '数据看板',
      //     notCache: true,
      //     access: ['home-statis']
      //   },
      //   component: () => import('@/view/home/index')
      // },
      {
        path: '/admin/user/info',
        name: 'userInfo',
        meta: {
          title: '个人设置',
          hideInMenu: true,
        },
        component: () => import('@/view/admin/userInfo')
      },
      // 预警记录
      {
        path: '/admin/alert/list',
        name: 'alertList',
        meta: {
          title: '预警记录',
          hideInMenu: true,
        },
        component: () => import('@/view/alert/alertRecords/alertRecordsList')
      },
    ]
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404')
  },

  // 基地管理
  {
    path: '/admin/base',
    name: `base`,
    meta: {
      title: '基地管理',
      icon: 'ios-paper',
      access: ['base']
    },
    component: Main,
    children: [
      // 地图总览
      {
        path: 'landBase/map',
        name: 'base-landBaseMap',
        meta: {
          title: '地图总览',
          access: ['base-landBaseMap']
        },
        component: () => import('@/view/landBase/landBaseMap')
      },
      {
        path: 'landBase/list',
        name: 'base-landBaseList',
        meta: {
          title: '基地信息',
          access: ['base-landBaseList']
        },
        component: () => import('@/view/landBase/landBase/landBaseList')
      },
      {
        path: 'landBase/edit/:id?',
        name: `base-landBaseEdit`,
        meta: {
          title: '基地信息 添加/编辑',
          hideInMenu: true,
          access: ['base-landBaseEdit']
        },
        component: () => import('@/view/landBase/landBase/landBaseEdit')
      },
      {
        path: 'landBase/info/:id?',
        name: `base-landBaseInfo`,
        meta: {
          title: '基地信息 查看',
          hideInMenu: true,
          access: ['base-landBaseInfo']
        },
        component: () => import('@/view/landBase/landBase/landBaseInfo')
      },
      // 基地管理员
      {
        path: 'landBaseAdmin/list',
        name: 'base-landBaseAdminList',
        meta: {
          title: '基地管理员',
          access: ['base-landBaseAdminList']
        },
        component: () => import('@/view/landBase/landBaseAdmin/landBaseAdminList')
      },
      // 基地管理员 添加/编辑
      {
        path: 'landBaseAdmin/edit/:id?',
        name: `base-landBaseAdminEdit`,
        meta: {
          title: '基地管理员 添加/编辑',
          hideInMenu: true,
          access: ['base-landBaseAdminEdit']
        },
        component: () => import('@/view/landBase/landBaseAdmin/landBaseAdminEdit')
      },
      // 基地管理员 查看
      {
        path: 'landBaseAdmin/info/:id?',
        name: `base-landBaseAdminInfo`,
        meta: {
          title: '基地管理员 查看',
          hideInMenu: true,
          access: ['base-landBaseAdminInfo']
        },
        component: () => import('@/view/landBase/landBaseAdmin/landBaseAdminInfo')
      },
      // 基地用户
      {
        path: 'landBaseUser/list',
        name: 'base-landBaseUserList',
        meta: {
          title: '基地用户',
          access: ['base-landBaseUserList']
        },
        component: () => import('@/view/landBase/landBaseUser/landBaseUserList')
      },
      // 基地用户 添加/编辑
      {
        path: 'landBaseUser/edit/:id?',
        name: `base-landBaseUserEdit`,
        meta: {
          title: '基地用户 添加/编辑',
          hideInMenu: true,
          access: ['base-landBaseUserEdit']
        },
        component: () => import('@/view/landBase/landBaseUser/landBaseUserEdit')
      },
      // 基地用户 查看
      {
        path: 'landBaseUser/info/:id?',
        name: `base-landBaseUserInfo`,
        meta: {
          title: '基地用户 查看',
          hideInMenu: true,
          access: ['base-landBaseUserInfo']
        },
        component: () => import('@/view/landBase/landBaseUser/landBaseUserInfo')
      },

      {
        path: 'landInfo/list',
        name: 'base-landInfoList',
        meta: {
          title: '地块信息',
          access: ['base-landInfoList']
        },
        component: () => import('@/view/landBase/landInfo/landInfoList')
      },
      {
        path: 'landInfo/edit/:id?',
        name: `base-landInfoEdit`,
        meta: {
          title: '地块信息 添加/编辑',
          hideInMenu: true,
          access: ['base-landInfoEdit']
        },
        component: () => import('@/view/landBase/landInfo/landInfoEdit')
      },
      {
        path: 'landInfo/info/:id?',
        name: `base-landInfoInfo`,
        meta: {
          title: '基地信息 查看',
          hideInMenu: true,
          access: ['base-landInfoInfo']
        },
        component: () => import('@/view/landBase/landInfo/landInfoInfo')
      }

    ]
  },

  // 数字种植管理
  {
    path: '/admin/digitalPlanting',
    name: `digitalPlanting`,
    meta: {
      title: '数字种植管理',
      icon: 'md-list-box',
      access: ['digitalPlanting']
    },
    component: Main,
    children: [
      // 数据可视化 单个基地
      // {
      //   path: 'dataVisualization',
      //   name: `digitalPlanting-dataVisualization`,
      //   meta: {
      //     title: '数据可视化',
      //     access: ['digitalPlanting-dataVisualization']
      //   },
      //   component: () => import('@/view/plant/dataVisualization')
      // },
      // 数据可视化 所有基地
      {
        path: 'dataVisualizationAll',
        name: `digitalPlanting-dataVisualizationAll`,
        meta: {
          title: '数据可视化',
          access: ['digitalPlanting-dataVisualizationAll']
        },
        component: () => import('@/view/plant/dataVisualizationAll')
      },
      // 种植信息
      {
        path: 'plantingInfo',
        name: `digitalPlanting-plantingInfo`,
        meta: {
          title: '种植信息',
          access: ['digitalPlanting-plantingInfo']
        },
        component: parentView,
        children: [
          // 播种记录
          {
            path: 'plantInfo/list',
            name: 'digitalPlanting-plantingInfo-plantInfoList',
            meta: {
              title: '播种记录',
              access: ['digitalPlanting-plantingInfo-plantInfoList']
            },
            component: () => import('@/view/plant/plantInfo/plantInfoList')
          },
          // 播种记录 添加/编辑
          {
            path: 'plantInfo/edit/:id?',
            name: `digitalPlanting-plantingInfo-plantInfoEdit`,
            meta: {
              title: '播种记录 添加/编辑',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantInfoEdit']
            },
            component: () => import('@/view/plant/plantInfo/plantInfoEdit')
          },
          // 播种记录 查看
          {
            path: 'plantInfo/info/:id?',
            name: `digitalPlanting-plantingInfo-plantInfoInfo`,
            meta: {
              title: '播种记录 查看',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantInfoInfo']
            },
            component: () => import('@/view/plant/plantInfo/plantInfoInfo')
          },
          // 投入记录
          {
            path: 'plantManure/list',
            name: 'digitalPlanting-plantingInfo-plantManureList',
            meta: {
              title: '投入品记录',
              access: ['digitalPlanting-plantingInfo-plantManureList']
            },
            component: () => import('@/view/plant/plantManure/plantManureList')
          },
          // 投入记录 添加/编辑
          {
            path: 'plantManure/edit/:id?',
            name: `digitalPlanting-plantingInfo-plantManureEdit`,
            meta: {
              title: '投入品记录 添加/编辑',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantManureEdit']
            },
            component: () => import('@/view/plant/plantManure/plantManureEdit')
          },
          // 投入记录 查看
          {
            path: 'plantManure/info/:id?',
            name: `digitalPlanting-plantingInfo-plantManureInfo`,
            meta: {
              title: '投入品记录 查看',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantManureInfo']
            },
            component: () => import('@/view/plant/plantManure/plantManureInfo')
          },

          // 灌溉记录
          {
            path: 'plantWater/list',
            name: 'digitalPlanting-plantingInfo-plantWaterList',
            meta: {
              title: '灌溉记录',
              access: ['digitalPlanting-plantingInfo-plantWaterList']
            },
            component: () => import('@/view/plant/plantWater/plantWaterList')
          },
          // 灌溉记录 添加/编辑
          {
            path: 'plantWater/edit/:id?',
            name: `digitalPlanting-plantingInfo-plantWaterEdit`,
            meta: {
              title: '灌溉记录 添加/编辑',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantWaterEdit']
            },
            component: () => import('@/view/plant/plantWater/plantWaterEdit')
          },
          // 灌溉记录 查看
          {
            path: 'plantWater/info/:id?',
            name: `digitalPlanting-plantingInfo-plantWaterInfo`,
            meta: {
              title: '灌溉记录 查看',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantWaterInfo']
            },
            component: () => import('@/view/plant/plantWater/plantWaterInfo')
          },
          // 剪枝记录
          {
            path: 'plantCut/list',
            name: 'digitalPlanting-plantingInfo-plantCutList',
            meta: {
              title: '剪枝记录',
              access: ['digitalPlanting-plantingInfo-plantCutList']
            },
            component: () => import('@/view/plant/plantCut/plantCutList')
          },
          // 剪枝记录 添加/编辑
          {
            path: 'plantCut/edit/:id?',
            name: `digitalPlanting-plantingInfo-plantCutEdit`,
            meta: {
              title: '剪枝记录 添加/编辑',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantCutEdit']
            },
            component: () => import('@/view/plant/plantCut/plantCutEdit')
          },
          // 剪枝记录 查看
          {
            path: 'plantCut/info/:id?',
            name: `digitalPlanting-plantingInfo-plantCutInfo`,
            meta: {
              title: '剪枝记录 查看',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantCutInfo']
            },
            component: () => import('@/view/plant/plantCut/plantCutInfo')
          },
          // 病虫防治记录
          {
            path: 'plantPests/list',
            name: 'digitalPlanting-plantingInfo-plantPestsList',
            meta: {
              title: '病虫防治记录',
              access: ['digitalPlanting-plantingInfo-plantPestsList']
            },
            component: () => import('@/view/plant/plantPests/plantPestsList')
          },
          // 病虫防治记录 添加/编辑
          {
            path: 'plantPests/edit/:id?',
            name: `digitalPlanting-plantingInfo-plantPestsEdit`,
            meta: {
              title: '病虫防治记录 添加/编辑',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantPestsEdit']
            },
            component: () => import('@/view/plant/plantPests/plantPestsEdit')
          },
          // 病虫防治记录 查看
          {
            path: 'plantPests/info/:id?',
            name: `digitalPlanting-plantingInfo-plantPestsInfo`,
            meta: {
              title: '病虫防治记录 查看',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantPestsInfo']
            },
            component: () => import('@/view/plant/plantPests/plantPestsInfo')
          },
          // 采摘记录
          {
            path: 'plantPicks/list',
            name: 'digitalPlanting-plantingInfo-plantPicksList',
            meta: {
              title: '采摘记录',
              access: ['digitalPlanting-plantingInfo-plantPicksList']
            },
            component: () => import('@/view/plant/plantPicks/plantPicksList')
          },
          // 采摘记录 添加/编辑
          {
            path: 'plantPicks/edit/:id?',
            name: `digitalPlanting-plantingInfo-plantPicksEdit`,
            meta: {
              title: '采摘记录 添加/编辑',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantPicksEdit']
            },
            component: () => import('@/view/plant/plantPicks/plantPicksEdit')
          },
          // 采摘记录 查看
          {
            path: 'plantPicks/info/:id?',
            name: `digitalPlanting-plantingInfo-plantPicksInfo`,
            meta: {
              title: '采摘记录 查看',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantPicksInfo']
            },
            component: () => import('@/view/plant/plantPicks/plantPicksInfo')
          },
          // 采摘销售
          {
            path: 'plantSale/list',
            name: 'digitalPlanting-plantingInfo-plantSaleList',
            meta: {
              title: '采摘销售',
              access: ['digitalPlanting-plantingInfo-plantSaleList']
            },
            component: () => import('@/view/plant/plantSale/plantSaleList')
          },
          // 采摘销售 添加/编辑
          {
            path: 'plantSale/edit/:id?',
            name: `digitalPlanting-plantingInfo-plantSaleEdit`,
            meta: {
              title: '采摘销售 添加/编辑',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantSaleEdit']
            },
            component: () => import('@/view/plant/plantSale/plantSaleEdit')
          },
          // 采摘销售 查看
          {
            path: 'plantSale/info/:id?',
            name: `digitalPlanting-plantingInfo-plantSaleInfo`,
            meta: {
              title: '采摘销售 查看',
              hideInMenu: true,
              access: ['digitalPlanting-plantingInfo-plantSaleInfo']
            },
            component: () => import('@/view/plant/plantSale/plantSaleInfo')
          }

        ]
      },

      // 农资用品
      {
        path: 'fertilizer',
        name: `digitalPlanting-fertilizer`,
        meta: {
          title: '农资用品',
          access: ['digitalPlanting-fertilizer']
        },
        component: parentView,
        children: [
          // 农资库存
          {
            path: 'plantThingsStock/list',
            name: 'digitalPlanting-fertilizer-plantThingsStockList',
            meta: {
              title: '投入品信息',
              access: ['digitalPlanting-fertilizer-plantThingsStockList']
            },
            component: () => import('@/view/plant/plantThingsStock/plantThingsStockList')
          },
          // 农资库存 添加/编辑
          {
            path: 'plantThingsStock/edit/:id?',
            name: `digitalPlanting-fertilizer-plantThingsStockEdit`,
            meta: {
              title: '投入品信息 添加/编辑',
              hideInMenu: true,
              access: ['digitalPlanting-fertilizer-plantThingsStockEdit']
            },
            component: () => import('@/view/plant/plantThingsStock/plantThingsStockEdit')
          },
          // 农资库存 查看
          {
            path: 'plantThingsStock/info/:id?',
            name: `digitalPlanting-fertilizer-plantThingsStockInfo`,
            meta: {
              title: '投入品信息 查看',
              hideInMenu: true,
              access: ['digitalPlanting-fertilizer-plantThingsStockInfo']
            },
            component: () => import('@/view/plant/plantThingsStock/plantThingsStockInfo')
          },
          // 农资库存记录
          {
            path: 'plantThingsStockLog/list',
            name: 'digitalPlanting-fertilizer-plantThingsStockLogList',
            meta: {
              title: '库存记录',
              access: ['digitalPlanting-fertilizer-plantThingsStockLogList']
            },
            component: () => import('@/view/plant/plantThingsStockLog/plantThingsStockLogList')
          },
          // 农资库存记录 添加/编辑
          {
            path: 'plantThingsStockLog/edit/:id?',
            name: `digitalPlanting-fertilizer-plantThingsStockLogEdit`,
            meta: {
              title: '库存记录 添加/编辑',
              hideInMenu: true,
              access: ['digitalPlanting-fertilizer-plantThingsStockLogEdit']
            },
            component: () => import('@/view/plant/plantThingsStockLog/plantThingsStockLogEdit')
          },
          // 农资库存记录 查看
          {
            path: 'plantThingsStockLog/info/:id?',
            name: `digitalPlanting-fertilizer-plantThingsStockLogInfo`,
            meta: {
              title: '库存记录 查看',
              hideInMenu: true,
              access: ['digitalPlanting-fertilizer-plantThingsStockLogInfo']
            },
            component: () => import('@/view/plant/plantThingsStockLog/plantThingsStockLogInfo')
          }

        ]
      },

      // 农机管理
      {
        path: 'agriculturalMachinery',
        name: `digitalPlanting-agriculturalMachinery`,
        meta: {
          title: '农机管理',
          access: ['digitalPlanting-agriculturalMachinery']
        },
        component: parentView,
        children: [
          // 农机设备
          {
            path: 'agriculturalMachinery/list',
            name: 'digitalPlanting-agriculturalMachinery-list',
            meta: {
              title: '农机设备',
              access: ['digitalPlanting-agriculturalMachinery-list']
            },
            component: () => import('@/view/plant/agriculturalMachinery/agriculturalMachinery/agriculturalMachineryList')
          },
          // 农机设备 查看
          {
            path: 'agriculturalMachinery/info/:id?',
            name: `digitalPlanting-agriculturalMachinery-info`,
            meta: {
              title: '农机设备 查看',
              hideInMenu: true,
              access: ['digitalPlanting-agriculturalMachinery-info']
            },
            component: () => import('@/view/plant/agriculturalMachinery/agriculturalMachinery/agriculturalMachineryInfo')
          },
          // 作业记录
          {
            path: 'agriculturalMachinery/jobRecords/list',
            name: 'digitalPlanting-agriculturalMachinery-jobRecordsList',
            meta: {
              title: '作业记录',
              access: ['digitalPlanting-agriculturalMachinery-jobRecordsList']
            },
            component: () => import('@/view/plant/agriculturalMachinery/agriculturalMachineryJobRecords/agriculturalMachineryJobRecordsList')
          },
          // 作业记录 同步
          {
            path: 'agriculturalMachinery/jobRecords/sync',
            name: `digitalPlanting-agriculturalMachinery-jobRecordsSync`,
            meta: {
              title: '作业记录 同步',
              hideInMenu: true,
              access: ['digitalPlanting-agriculturalMachinery-jobRecordsSync']
            },
            component: () => import('@/view/plant/agriculturalMachinery/agriculturalMachineryJobRecords/agriculturalMachineryJobRecordsSync')
          },
          // 作业记录 查看
          {
            path: 'agriculturalMachinery/jobRecords/info/:id?',
            name: `digitalPlanting-agriculturalMachinery-jobRecordsInfo`,
            meta: {
              title: '作业记录 查看',
              hideInMenu: true,
              access: ['digitalPlanting-agriculturalMachinery-jobRecordsInfo']
            },
            component: () => import('@/view/plant/agriculturalMachinery/agriculturalMachineryJobRecords/agriculturalMachineryJobRecordsInfo')
          }
        ]
      },

      // 设备管理
      {
        path: 'plantDevice',
        name: `digitalPlanting-plantDevice`,
        meta: {
          title: '设备管理',
          access: ['digitalPlanting-plantDevice']
        },
        component: parentView,
        children: [
          // 气象设备
          {
            path: 'plantDevice/meteorology/list',
            name: 'digitalPlanting-plantDevice-meteorologyList',
            meta: {
              title: '气象设备',
              access: ['digitalPlanting-plantDevice-meteorologyList']
            },
            component: () => import('@/view/plant/plantDevice/plantDeviceMeteorologyList')
          },
          // 气象设备 历史记录
          {
            path: 'plantDevice/meteorology/log/list/:id?',
            name: `digitalPlanting-plantDevice-meteorologyLogList`,
            meta: {
              title: '气象设备 历史记录',
              hideInMenu: true, // 菜单栏不显示
              access: ['digitalPlanting-plantDevice-meteorologyLogList']
            },
            component: () => import('@/view/plant/plantDevice/plantDeviceMeteorologyLogList')
          },
          // 土壤设备
          {
            path: 'plantDevice/soil/list',
            name: 'digitalPlanting-plantDevice-soilList',
            meta: {
              title: '土壤设备',
              access: ['digitalPlanting-plantDevice-soilList']
            },
            component: () => import('@/view/plant/plantDevice/plantDeviceSoilList')
          },
          // 土壤设备 历史记录
          {
            path: 'plantDevice/soil/log/list/:id?',
            name: `digitalPlanting-plantDevice-soilLogList`,
            meta: {
              title: '土壤设备 历史记录',
              hideInMenu: true, // 菜单栏不显示
              access: ['digitalPlanting-plantDevice-soilLogList']
            },
            component: () => import('@/view/plant/plantDevice/plantDeviceSoilLogList')
          },
          // 虫情设备
          {
            path: 'plantDevice/pest/list',
            name: 'digitalPlanting-plantDevice-pestList',
            meta: {
              title: '虫情设备',
              access: ['digitalPlanting-plantDevice-pestList']
            },
            component: () => import('@/view/plant/plantDevice/plantDevicePestList')
          },
          // 虫情设备 历史记录
          {
            path: 'plantDevice/pest/log/list/:id?',
            name: `digitalPlanting-plantDevice-pestLogList`,
            meta: {
              title: '虫情设备 历史记录',
              hideInMenu: true, // 菜单栏不显示
              access: ['digitalPlanting-plantDevice-pestLogList']
            },
            component: () => import('@/view/plant/plantDevice/plantDevicePestLogList')
          },
          // 灌溉设备
          {
            path: 'plantDevice/irrigation/list',
            name: 'digitalPlanting-plantDevice-irrigationList',
            meta: {
              title: '灌溉设备',
              access: ['digitalPlanting-plantDevice-irrigationList']
            },
            component: () => import('@/view/plant/plantDevice/plantDeviceIrrigationList')
          },
          // 监控设备 苗情设备
          {
            path: 'plantDevice/monitoring/list',
            name: 'digitalPlanting-plantDevice-monitoringList',
            meta: {
              title: '苗情设备',
              access: ['digitalPlanting-plantDevice-monitoringList']
            },
            component: () => import('@/view/plant/plantDevice/plantDeviceMonitoringList')
          }
        ]
      }
    ]
  },

  // 数字养殖管理
  {
    path: '/admin/digitalLivestock',
    name: `digitalLivestock`,
    meta: {
      title: '数字养殖管理',
      icon: 'md-list-box',
      access: ['digitalLivestock']
    },
    component: Main,
    children: [
      {
        path: 'cattleFarm',
        name: `digitalLivestock-cattleFarm`,
        meta: {
          title: '数字养牛基地',
          access: ['digitalLivestock-cattleFarm']
        },
        component: parentView,
        children: [
          // 数据可视化
          {
            path: 'dataVisualization',
            name: `digitalLivestock-cattleFarm-dataVisualization`,
            meta: {
              title: '数据可视化',
              access: ['digitalLivestock-cattleFarm-dataVisualization']
            },
            component: () => import('@/view/cattleFarm/dataVisualization')
          },
          // 畜禽管理
          {
            path: 'base',
            name: `digitalLivestock-cattleFarm-base`,
            meta: {
              title: '畜禽管理',
              access: ['digitalLivestock-cattleFarm-base']
            },
            component: parentView,
            children: [
              // 圈舍列表
              {
                path: 'colonyHouse/list',
                name: `digitalLivestock-cattleFarm-base-cattleHouseList`,
                meta: {
                  title: '圈舍管理',
                  access: ['digitalLivestock-cattleFarm-base-cattleHouseList']
                },
                component: () => import('@/view/cattleFarm/cattleHouse/cattleHouseList')
              },
              // 圈舍编辑
              {
                path: 'colonyHouse/edit/:id?',
                name: `digitalLivestock-cattleFarm-base-cattleHouseEdit`,
                meta: {
                  title: '圈舍信息 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-base-cattleHouseEdit']
                },
                component: () => import('@/view/cattleFarm/cattleHouse/cattleHouseEdit')
              },
              // 圈舍详情
              {
                path: 'colonyHouse/info/:id?',
                name: `digitalLivestock-cattleFarm-base-cattleHouseInfo`,
                meta: {
                  title: '圈舍信息 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-base-cattleHouseInfo']
                },
                component: () => import('@/view/cattleFarm/cattleHouse/cattleHouseInfo')
              },
              // 养殖人员列表
              {
                path: 'user/list',
                name: `digitalLivestock-cattleFarm-base-userList`,
                meta: {
                  title: '养殖人员',
                  access: ['digitalLivestock-cattleFarm-base-userList']
                },
                component: () => import('@/view/cattleFarm/cattleUser/cattleUserList')
              },
              // 养殖人员编辑
              {
                path: 'user/edit/:id?',
                name: `digitalLivestock-cattleFarm-base-userEdit`,
                meta: {
                  title: '养殖人员 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-base-userEdit']
                },
                component: () => import('@/view/cattleFarm/cattleUser/cattleUserEdit')
              },
              // 养殖人员查看
              {
                path: 'user/info/:id?',
                name: `digitalLivestock-cattleFarm-base-userInfo`,
                meta: {
                  title: '养殖人员 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-base-userInfo']
                },
                component: () => import('@/view/cattleFarm/cattleUser/cattleUserInfo')
              },
              // 人员排班
              {
                path: 'cattleDuty/edit',
                name: `digitalLivestock-cattleFarm-base-cattleDutyEdit`,
                meta: {
                  title: '人员排班',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-base-cattleDutyEdit']
                },
                component: () => import('@/view/cattleFarm/cattleDuty/cattleDutyEdit')
              },
              // 畜禽信息列表
              {
                path: 'cattleInfo/list',
                name: `digitalLivestock-cattleFarm-base-cattleInfoList`,
                meta: {
                  title: '畜禽信息',
                  access: ['digitalLivestock-cattleFarm-base-cattleInfoList']
                },
                component: () => import('@/view/cattleFarm/cattleInfo/cattleInfoList')
              },
              // 畜禽信息编辑
              {
                path: 'cattleInfo/edit/:id?',
                name: `digitalLivestock-cattleFarm-base-cattleInfoEdit`,
                meta: {
                  title: '畜禽信息 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-base-cattleInfoEdit']
                },
                component: () => import('@/view/cattleFarm/cattleInfo/cattleInfoEdit')
              },
              // 畜禽信息查看
              {
                path: 'cattleInfo/info/:id?',
                name: `digitalLivestock-cattleFarm-base-cattleInfoInfo`,
                meta: {
                  title: '畜禽信息 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-base-cattleInfoInfo']
                },
                component: () => import('@/view/cattleFarm/cattleInfo/cattleInfoInfo')
              },
              // 转舍列表
              {
                path: 'cattleTransfer/list',
                name: `digitalLivestock-cattleFarm-base-cattleTransferList`,
                meta: {
                  title: '转舍管理',
                  access: ['digitalLivestock-cattleFarm-base-cattleTransferList']
                },
                component: () => import('@/view/cattleFarm/cattleTransfer/cattleTransferList')
              },
              // 转舍添加
              {
                path: 'cattleTransfer/edit/:id?',
                name: `digitalLivestock-cattleFarm-base-cattleTransferEdit`,
                meta: {
                  title: '转舍管理 添加',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-base-cattleTransferEdit']
                },
                component: () => import('@/view/cattleFarm/cattleTransfer/cattleTransferEdit')
              },
              // 转舍查看
              {
                path: 'cattleTransfer/info/:id?',
                name: `digitalLivestock-cattleFarm-base-cattleTransferInfo`,
                meta: {
                  title: '转舍管理 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-base-cattleTransferInfo']
                },
                component: () => import('@/view/cattleFarm/cattleTransfer/cattleTransferInfo')
              },
            ]
          },
          // 繁育管理
          {
            path: 'breeding',
            name: `digitalLivestock-cattleFarm-breeding`,
            meta: {
              title: '繁育管理',
              access: ['digitalLivestock-cattleFarm-breeding']
            },
            component: parentView,
            children: [
              // 繁育存栏
              {
                path: 'cattleBreedInfo/list',
                name: `digitalLivestock-cattleFarm-breeding-cattleBreedInfoList`,
                meta: {
                  title: '繁育存栏',
                  access: ['digitalLivestock-cattleFarm-breeding-cattleBreedInfoList']
                },
                component: () => import('@/view/cattleFarm/cattleBreedInfo/cattleBreedInfoList')
              },
              // 繁育存栏 添加/编辑
              {
                path: 'cattleBreedInfo/edit/:id?',
                name: `digitalLivestock-cattleFarm-breeding-cattleBreedInfoEdit`,
                meta: {
                  title: '繁育存栏 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-breeding-cattleBreedInfoEdit']
                },
                component: () => import('@/view/cattleFarm/cattleBreedInfo/cattleBreedInfoEdit')
              },
              // 繁育存栏 查看
              {
                path: 'cattleBreedInfo/info/:id?',
                name: `digitalLivestock-cattleFarm-breeding-cattleBreedInfoInfo`,
                meta: {
                  title: '繁育存栏 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-breeding-cattleBreedInfoInfo']
                },
                component: () => import('@/view/cattleFarm/cattleBreedInfo/cattleBreedInfoInfo')
              },
              // 繁育寄养
              {
                path: 'cattleBreedFoster/list',
                name: `digitalLivestock-cattleFarm-breeding-cattleBreedFosterList`,
                meta: {
                  title: '繁育寄养',
                  access: ['digitalLivestock-cattleFarm-breeding-cattleBreedFosterList']
                },
                component: () => import('@/view/cattleFarm/cattleBreedFoster/cattleBreedFosterList')
              },
              // 繁育寄养 添加/编辑
              {
                path: 'cattleBreedFoster/edit/:id?',
                name: `digitalLivestock-cattleFarm-breeding-cattleBreedFosterEdit`,
                meta: {
                  title: '繁育寄养 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-breeding-cattleBreedFosterEdit']
                },
                component: () => import('@/view/cattleFarm/cattleBreedFoster/cattleBreedFosterEdit')
              },
              // 繁育寄养 查看
              {
                path: 'cattleBreedFoster/info/:id?',
                name: `digitalLivestock-cattleFarm-breeding-cattleBreedFosterInfo`,
                meta: {
                  title: '繁育寄养 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-breeding-cattleBreedFosterInfo']
                },
                component: () => import('@/view/cattleFarm/cattleBreedFoster/cattleBreedFosterInfo')
              },
              // 配种记录
              {
                path: 'cattleBreedCopulation/list',
                name: `digitalLivestock-cattleFarm-breeding-cattleBreedCopulationList`,
                meta: {
                  title: '配种记录',
                  access: ['digitalLivestock-cattleFarm-breeding-cattleBreedCopulationList']
                },
                component: () => import('@/view/cattleFarm/cattleBreedCopulation/cattleBreedCopulationList')
              },
              // 配种记录 添加/编辑
              {
                path: 'cattleBreedCopulation/edit/:id?',
                name: `digitalLivestock-cattleFarm-breeding-cattleBreedCopulationEdit`,
                meta: {
                  title: '配种记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-breeding-cattleBreedCopulationEdit']
                },
                component: () => import('@/view/cattleFarm/cattleBreedCopulation/cattleBreedCopulationEdit')
              },
              // 配种记录 查看
              {
                path: 'cattleBreedCopulation/info/:id?',
                name: `digitalLivestock-cattleFarm-breeding-cattleBreedCopulationInfo`,
                meta: {
                  title: '配种记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-breeding-cattleBreedCopulationInfo']
                },
                component: () => import('@/view/cattleFarm/cattleBreedCopulation/cattleBreedCopulationInfo')
              },
              // 繁育记录
              {
                path: 'cattleBreedLog/list',
                name: `digitalLivestock-cattleFarm-breeding-cattleBreedLogList`,
                meta: {
                  title: '繁育记录',
                  access: ['digitalLivestock-cattleFarm-breeding-cattleBreedLogList']
                },
                component: () => import('@/view/cattleFarm/cattleBreedLog/cattleBreedLogList')
              },
              // 繁育记录 添加/编辑
              {
                path: 'cattleBreedLog/edit/:id?',
                name: `digitalLivestock-cattleFarm-breeding-cattleBreedLogEdit`,
                meta: {
                  title: '繁育记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-breeding-cattleBreedLogEdit']
                },
                component: () => import('@/view/cattleFarm/cattleBreedLog/cattleBreedLogEdit')
              },
              // 繁育记录 查看
              {
                path: 'cattleBreedLog/info/:id?',
                name: `digitalLivestock-cattleFarm-breeding-cattleBreedLogInfo`,
                meta: {
                  title: '繁育记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-breeding-cattleBreedLogInfo']
                },
                component: () => import('@/view/cattleFarm/cattleBreedLog/cattleBreedLogInfo')
              }
            ]
          },
          // 饲料管理
          {
            path: 'fodderManage',
            name: `digitalLivestock-cattleFarm-fodderManage`,
            meta: {
              title: '饲料管理',
              access: ['digitalLivestock-cattleFarm-fodderManage']
            },
            component: parentView,
            children: [
              // 库存记录
              {
                path: 'cattleFodder/list',
                name: `digitalLivestock-cattleFarm-fodderManage-cattleFodderList`,
                meta: {
                  title: '库存记录',
                  access: ['digitalLivestock-cattleFarm-fodderManage-cattleFodderList']
                },
                component: () => import('@/view/cattleFarm/cattleFodder/cattleFodderList')
              },
              // 库存记录 添加/编辑
              {
                path: 'cattleFodder/edit/:id?',
                name: `digitalLivestock-cattleFarm-fodderManage-cattleFodderEdit`,
                meta: {
                  title: '库存记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-fodderManage-cattleFodderEdit']
                },
                component: () => import('@/view/cattleFarm/cattleFodder/cattleFodderEdit')
              },
              // 库存记录 查看
              {
                path: 'cattleFodder/info/:id?',
                name: `digitalLivestock-cattleFarm-fodderManage-cattleFodderInfo`,
                meta: {
                  title: '库存记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-fodderManage-cattleFodderInfo']
                },
                component: () => import('@/view/cattleFarm/cattleFodder/cattleFodderInfo')
              },
              // 投放记录
              {
                path: 'cattleFodderLog/list',
                name: `digitalLivestock-cattleFarm-fodderManage-cattleFodderLogList`,
                meta: {
                  title: '投放记录',
                  access: ['digitalLivestock-cattleFarm-fodderManage-cattleFodderLogList']
                },
                component: () => import('@/view/cattleFarm/cattleFodderLog/cattleFodderLogList')
              },
              // 投放记录 添加/编辑
              {
                path: 'cattleFodderLog/edit/:id?',
                name: `digitalLivestock-cattleFarm-fodderManage-cattleFodderLogEdit`,
                meta: {
                  title: '投放记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-fodderManage-cattleFodderLogEdit']
                },
                component: () => import('@/view/cattleFarm/cattleFodderLog/cattleFodderLogEdit')
              },
              // 投放记录 查看
              {
                path: 'cattleFodderLog/info/:id?',
                name: `digitalLivestock-cattleFarm-fodderManage-cattleFodderLogInfo`,
                meta: {
                  title: '投放记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-fodderManage-cattleFodderLogInfo']
                },
                component: () => import('@/view/cattleFarm/cattleFodderLog/cattleFodderLogInfo')
              }
            ]
          },
          // 出栏管理
          {
            path: 'outManage',
            name: `digitalLivestock-cattleFarm-outManage`,
            meta: {
              title: '出栏管理',
              access: ['digitalLivestock-cattleFarm-outManage']
            },
            component: parentView,
            children: [
              // 出栏记录
              {
                path: 'cattleOut/list',
                name: `digitalLivestock-cattleFarm-outManage-cattleOutList`,
                meta: {
                  title: '出栏记录',
                  access: ['digitalLivestock-cattleFarm-outManage-cattleOutList']
                },
                component: () => import('@/view/cattleFarm/cattleOut/cattleOutList')
              },
              // 出栏记录 添加/编辑
              {
                path: 'cattleOut/edit/:id?',
                name: `digitalLivestock-cattleFarm-outManage-cattleOutEdit`,
                meta: {
                  title: '出栏记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-outManage-cattleOutEdit']
                },
                component: () => import('@/view/cattleFarm/cattleOut/cattleOutEdit')
              },
              // 出栏记录 查看
              {
                path: 'cattleOut/info/:id?',
                name: `digitalLivestock-cattleFarm-outManage-cattleOutInfo`,
                meta: {
                  title: '出栏记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-outManage-cattleOutInfo']
                },
                component: () => import('@/view/cattleFarm/cattleOut/cattleOutInfo')
              }
            ]
          },
          // 屠宰管理
          {
            path: 'slaughterManage',
            name: `digitalLivestock-cattleFarm-slaughterManage`,
            meta: {
              title: '屠宰管理',
              access: ['digitalLivestock-cattleFarm-slaughterManage']
            },
            component: parentView,
            children: [
              // 静养圈管理 cattleSlaughterRest
              {
                path: 'cattleSlaughterRest/list',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterRestList`,
                meta: {
                  title: '静养圈管理',
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterRestList']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterRest/cattleSlaughterRestList')
              },
              // 静养圈管理 添加/编辑
              {
                path: 'cattleSlaughterRest/edit/:id?',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterRestEdit`,
                meta: {
                  title: '静养圈管理 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterRestEdit']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterRest/cattleSlaughterRestEdit')
              },
              // 静养圈管理 查看
              {
                path: 'cattleSlaughterRest/info/:id?',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterRestInfo`,
                meta: {
                  title: '静养圈管理 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterRestInfo']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterRest/cattleSlaughterRestInfo')
              },

              // 检疫记录
              {
                path: 'cattleSlaughterQuarantine/list',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterQuarantineList`,
                meta: {
                  title: '检疫记录',
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterQuarantineList']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterQuarantine/cattleSlaughterQuarantineList')
              },
              // 检疫记录 添加/编辑
              {
                path: 'cattleSlaughterQuarantine/edit/:id?',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterQuarantineEdit`,
                meta: {
                  title: '检疫记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterQuarantineEdit']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterQuarantine/cattleSlaughterQuarantineEdit')
              },
              // 检疫记录 查看
              {
                path: 'cattleSlaughterQuarantine/info/:id?',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterQuarantineInfo`,
                meta: {
                  title: '检疫记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterQuarantineInfo']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterQuarantine/cattleSlaughterQuarantineInfo')
              },

              // 屠宰记录
              {
                path: 'cattleSlaughterLog/list',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterLogList`,
                meta: {
                  title: '屠宰记录',
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterLogList']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterLog/cattleSlaughterLogList')
              },

              // 屠宰记录 添加/编辑
              {
                path: 'cattleSlaughterLog/edit/:id?',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterLogEdit`,
                meta: {
                  title: '屠宰记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterLogEdit']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterLog/cattleSlaughterLogEdit')
              },
              // 屠宰记录 查看
              {
                path: 'cattleSlaughterLog/info/:id?',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterLogInfo`,
                meta: {
                  title: '屠宰记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterLogInfo']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterLog/cattleSlaughterLogInfo')
              },

              // 出场记录 cattleSlaughterSalesLog
              {
                path: 'cattleSlaughterSalesLog/list',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterSalesLogList`,
                meta: {
                  title: '出场记录',
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterSalesLogList']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterSalesLog/cattleSlaughterSalesLogList')
              },
              // 出场记录 添加/编辑
              {
                path: 'cattleSlaughterSalesLog/edit/:id?',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterSalesLogEdit`,
                meta: {
                  title: '出场记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterSalesLogEdit']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterSalesLog/cattleSlaughterSalesLogEdit')
              },
              // 出场记录 查看
              {
                path: 'cattleSlaughterSalesLog/info/:id?',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterSalesLogInfo`,
                meta: {
                  title: '出场记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterSalesLogInfo']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterSalesLog/cattleSlaughterSalesLogInfo')
              },

              // 经销商管理
              {
                path: 'cattleSlaughterSales/list',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterSalesList`,
                meta: {
                  title: '经销商管理',
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterSalesList']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterSales/cattleSlaughterSalesList')
              },
              // 经销商管理 添加/编辑
              {
                path: 'cattleSlaughterSales/edit/:id?',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterSalesEdit`,
                meta: {
                  title: '经销商管理 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterSalesEdit']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterSales/cattleSlaughterSalesEdit')
              },
              // 经销商管理 查看
              {
                path: 'cattleSlaughterSales/info/:id?',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterSalesInfo`,
                meta: {
                  title: '经销商管理 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterSalesInfo']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughterSales/cattleSlaughterSalesInfo')
              },
              // 屠宰场管理
              {
                path: 'cattleSlaughter/list',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterList`,
                meta: {
                  title: '屠宰场管理',
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterList']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughter/cattleSlaughterList')
              },
              // 屠宰场管理 添加/编辑
              {
                path: 'cattleSlaughter/edit/:id?',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterEdit`,
                meta: {
                  title: '屠宰场管理 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterEdit']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughter/cattleSlaughterEdit')
              },
              // 屠宰场管理 查看
              {
                path: 'cattleSlaughter/info/:id?',
                name: `digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterInfo`,
                meta: {
                  title: '屠宰场管理 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-slaughterManage-cattleSlaughterInfo']
                },
                component: () => import('@/view/cattleFarm/cattleSlaughter/cattleSlaughterInfo')
              }
            ]
          },

          // 畜禽防疫
          {
            path: 'prevention',
            name: `digitalLivestock-cattleFarm-prevention`,
            meta: {
              title: '畜禽防疫',
              access: ['digitalLivestock-cattleFarm-prevention']
            },
            component: parentView,
            children: [
              // 接种记录
              {
                path: 'cattleInoculate/list',
                name: `digitalLivestock-cattleFarm-prevention-cattleInoculateList`,
                meta: {
                  title: '接种记录',
                  access: ['digitalLivestock-cattleFarm-prevention-cattleInoculateList']
                },
                component: () => import('@/view/cattleFarm/cattleInoculate/cattleInoculateList')
              },
              // 接种记录 添加/编辑
              {
                path: 'cattleInoculate/edit/:id?',
                name: `digitalLivestock-cattleFarm-prevention-cattleInoculateEdit`,
                meta: {
                  title: '接种记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-prevention-cattleInoculateEdit']
                },
                component: () => import('@/view/cattleFarm/cattleInoculate/cattleInoculateEdit')
              },
              // 接种记录 查看
              {
                path: 'cattleInoculate/info/:id?',
                name: `digitalLivestock-cattleFarm-prevention-cattleInoculateInfo`,
                meta: {
                  title: '接种记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-prevention-cattleInoculateInfo']
                },
                component: () => import('@/view/cattleFarm/cattleInoculate/cattleInoculateInfo')
              },

              // 用药记录
              {
                path: 'cattleMedicine/list',
                name: `digitalLivestock-cattleFarm-prevention-cattleMedicineList`,
                meta: {
                  title: '用药记录',
                  access: ['digitalLivestock-cattleFarm-prevention-cattleMedicineList']
                },
                component: () => import('@/view/cattleFarm/cattleMedicine/cattleMedicineList')
              },
              // 用药记录 添加/编辑
              {
                path: 'cattleMedicine/edit/:id?',
                name: `digitalLivestock-cattleFarm-prevention-cattleMedicineEdit`,
                meta: {
                  title: '用药记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-prevention-cattleMedicineEdit']
                },
                component: () => import('@/view/cattleFarm/cattleMedicine/cattleMedicineEdit')
              },
              // 用药记录 查看
              {
                path: 'cattleMedicine/info/:id?',
                name: `digitalLivestock-cattleFarm-prevention-cattleMedicineInfo`,
                meta: {
                  title: '用药记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-prevention-cattleMedicineInfo']
                },
                component: () => import('@/view/cattleFarm/cattleMedicine/cattleMedicineInfo')
              },

              // 佩标记录
              {
                path: 'cattleWearTag/list',
                name: `digitalLivestock-cattleFarm-prevention-cattleWearTagList`,
                meta: {
                  title: '佩标记录',
                  access: ['digitalLivestock-cattleFarm-prevention-cattleWearTagList']
                },
                component: () => import('@/view/cattleFarm/cattleWearTag/cattleWearTagList')
              },

              // 防疫检疫
              {
                path: 'cattleQuarantine/list',
                name: `digitalLivestock-cattleFarm-prevention-cattleQuarantineList`,
                meta: {
                  title: '防疫检疫',
                  access: ['digitalLivestock-cattleFarm-prevention-cattleQuarantineList']
                },
                component: () => import('@/view/cattleFarm/cattleQuarantine/cattleQuarantineList')
              },
              // 防疫检疫 添加/编辑
              {
                path: 'cattleQuarantine/edit/:id?',
                name: `digitalLivestock-cattleFarm-prevention-cattleQuarantineEdit`,
                meta: {
                  title: '防疫检疫 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-prevention-cattleQuarantineEdit']
                },
                component: () => import('@/view/cattleFarm/cattleQuarantine/cattleQuarantineEdit')
              },
              // 防疫检疫 查看
              {
                path: 'cattleQuarantine/info/:id?',
                name: `digitalLivestock-cattleFarm-prevention-cattleQuarantineInfo`,
                meta: {
                  title: '防疫检疫 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-prevention-cattleQuarantineInfo']
                },
                component: () => import('@/view/cattleFarm/cattleQuarantine/cattleQuarantineInfo')
              }
            ]
          },

          // 无害化管理
          {
            path: 'harmless',
            name: `digitalLivestock-cattleFarm-harmless`,
            meta: {
              title: '无害化管理',
              access: ['digitalLivestock-cattleFarm-harmless']
            },
            component: parentView,
            children: [
              // 死亡登记
              {
                path: 'cattleHarmlessDeath/list',
                name: `digitalLivestock-cattleFarm-harmless-cattleHarmlessDeathList`,
                meta: {
                  title: '死亡登记',
                  access: ['digitalLivestock-cattleFarm-harmless-cattleHarmlessDeathList']
                },
                component: () => import('@/view/cattleFarm/cattleHarmlessDeath/cattleHarmlessDeathList')
              },
              // 死亡登记 添加/编辑
              {
                path: 'cattleHarmlessDeath/edit/:id?',
                name: `digitalLivestock-cattleFarm-harmless-cattleHarmlessDeathEdit`,
                meta: {
                  title: '死亡登记 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-harmless-cattleHarmlessDeathEdit']
                },
                component: () => import('@/view/cattleFarm/cattleHarmlessDeath/cattleHarmlessDeathEdit')
              },
              // 死亡登记 查看
              {
                path: 'cattleHarmlessDeath/info/:id?',
                name: `digitalLivestock-cattleFarm-harmless-cattleHarmlessDeathInfo`,
                meta: {
                  title: '死亡登记 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-harmless-cattleHarmlessDeathInfo']
                },
                component: () => import('@/view/cattleFarm/cattleHarmlessDeath/cattleHarmlessDeathInfo')
              },

              // 收集记录
              {
                path: 'cattleHarmlessCollect/list',
                name: `digitalLivestock-cattleFarm-harmless-cattleHarmlessCollectList`,
                meta: {
                  title: '收集记录',
                  access: ['digitalLivestock-cattleFarm-harmless-cattleHarmlessCollectList']
                },
                component: () => import('@/view/cattleFarm/cattleHarmlessCollect/cattleHarmlessCollectList')
              },
              // 收集记录 添加/编辑
              {
                path: 'cattleHarmlessCollect/edit/:id?',
                name: `digitalLivestock-cattleFarm-harmless-cattleHarmlessCollectEdit`,
                meta: {
                  title: '收集记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-harmless-cattleHarmlessCollectEdit']
                },
                component: () => import('@/view/cattleFarm/cattleHarmlessCollect/cattleHarmlessCollectEdit')
              },
              // 收集记录 查看
              {
                path: 'cattleHarmlessCollect/info/:id?',
                name: `digitalLivestock-cattleFarm-harmless-cattleHarmlessCollectInfo`,
                meta: {
                  title: '收集记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-harmless-cattleHarmlessCollectInfo']
                },
                component: () => import('@/view/cattleFarm/cattleHarmlessCollect/cattleHarmlessCollectInfo')
              },

              // 无害化处理
              {
                path: 'cattleHarmlessInfo/list',
                name: `digitalLivestock-cattleFarm-harmless-cattleHarmlessInfoList`,
                meta: {
                  title: '无害化处理',
                  access: ['digitalLivestock-cattleFarm-harmless-cattleHarmlessInfoList']
                },
                component: () => import('@/view/cattleFarm/cattleHarmlessInfo/cattleHarmlessInfoList')
              },
              // 无害化处理 添加/编辑
              {
                path: 'cattleHarmlessInfo/edit/:id?',
                name: `digitalLivestock-cattleFarm-harmless-cattleHarmlessInfoEdit`,
                meta: {
                  title: '无害化处理 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-harmless-cattleHarmlessInfoEdit']
                },
                component: () => import('@/view/cattleFarm/cattleHarmlessInfo/cattleHarmlessInfoEdit')
              },
              // 无害化处理 查看
              {
                path: 'cattleHarmlessInfo/info/:id?',
                name: `digitalLivestock-cattleFarm-harmless-cattleHarmlessInfoInfo`,
                meta: {
                  title: '无害化处理 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-harmless-cattleHarmlessInfoInfo']
                },
                component: () => import('@/view/cattleFarm/cattleHarmlessInfo/cattleHarmlessInfoInfo')
              },

              // 保险理赔
              {
                path: 'cattleHarmlessInsurance/list',
                name: `digitalLivestock-cattleFarm-harmless-cattleHarmlessInsuranceList`,
                meta: {
                  title: '保险理赔',
                  access: ['digitalLivestock-cattleFarm-harmless-cattleHarmlessInsuranceList']
                },
                component: () => import('@/view/cattleFarm/cattleHarmlessInsurance/cattleHarmlessInsuranceList')
              },
              // 保险理赔 添加/编辑
              {
                path: 'cattleHarmlessInsurance/edit/:id?',
                name: `digitalLivestock-cattleFarm-harmless-cattleHarmlessInsuranceEdit`,
                meta: {
                  title: '保险理赔 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-harmless-cattleHarmlessInsuranceEdit']
                },
                component: () => import('@/view/cattleFarm/cattleHarmlessInsurance/cattleHarmlessInsuranceEdit')
              },
              // 保险理赔 查看
              {
                path: 'cattleHarmlessInsurance/info/:id?',
                name: `digitalLivestock-cattleFarm-harmless-cattleHarmlessInsuranceInfo`,
                meta: {
                  title: '保险理赔 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-cattleFarm-harmless-cattleHarmlessInsuranceInfo']
                },
                component: () => import('@/view/cattleFarm/cattleHarmlessInsurance/cattleHarmlessInsuranceInfo')
              }
            ]
          },
          // 设备管理
          {
            path: 'device',
            name: `digitalLivestock-cattleFarm-device`,
            meta: {
              title: '设备管理',
              access: ['digitalLivestock-cattleFarm-device']
            },
            component: parentView,
            children: [
              // 环境设备
              {
                path: 'cattleDeviceEnvironment/list',
                name: `digitalLivestock-cattleFarm-device-cattleDeviceEnvironmentList`,
                meta: {
                  title: '环境设备',
                  access: ['digitalLivestock-cattleFarm-device-cattleDeviceEnvironmentList']
                },
                component: () => import('@/view/cattleFarm/cattleDevice/cattleDeviceEnvironmentList')
              },
              // 环境设备 历史记录
              {
                path: 'cattleDeviceEnvironment/log/list/:id?',
                name: `digitalLivestock-cattleFarm-device-cattleDeviceEnvironmentLogList`,
                meta: {
                  title: '环境设备 历史记录',
                  hideInMenu: true, // 菜单栏不显示
                  access: ['digitalLivestock-cattleFarm-device-cattleDeviceEnvironmentLogList']
                },
                component: () => import('@/view/cattleFarm/cattleDevice/cattleDeviceEnvironmentLogList')
              },
              // 监控设备
              {
                path: 'cattleDeviceMonitoring/list',
                name: `digitalLivestock-cattleFarm-device-cattleDeviceMonitoringList`,
                meta: {
                  title: '监控设备',
                  access: ['digitalLivestock-cattleFarm-device-cattleDeviceMonitoringList']
                },
                component: () => import('@/view/cattleFarm/cattleDevice/cattleDeviceMonitoringList')
              }

            ]
          }

        ]
      },
      {
        path: 'pigFarm',
        name: `digitalLivestock-pigFarm`,
        meta: {
          title: '数字养猪基地',
          access: ['digitalLivestock-pigFarm']
        },
        component: parentView,
        children: [
          // 数据可视化
          {
            path: 'dataVisualization',
            name: `digitalLivestock-pigFarm-dataVisualization`,
            meta: {
              title: '数据可视化',
              access: ['digitalLivestock-pigFarm-dataVisualization']
            },
            component: () => import('@/view/pigFarm/dataVisualization')
          },
          // 畜禽管理
          {
            path: 'base',
            name: `digitalLivestock-pigFarm-base`,
            meta: {
              title: '畜禽管理',
              access: ['digitalLivestock-pigFarm-base']
            },
            component: parentView,
            children: [
              // 圈舍列表
              {
                path: 'colonyHouse/list',
                name: `digitalLivestock-pigFarm-base-pigHouseList`,
                meta: {
                  title: '圈舍管理',
                  access: ['digitalLivestock-pigFarm-base-pigHouseList']
                },
                component: () => import('@/view/pigFarm/pigHouse/pigHouseList')
              },
              // 圈舍编辑
              {
                path: 'colonyHouse/edit/:id?',
                name: `digitalLivestock-pigFarm-base-pigHouseEdit`,
                meta: {
                  title: '圈舍信息 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-base-pigHouseEdit']
                },
                component: () => import('@/view/pigFarm/pigHouse/pigHouseEdit')
              },
              // 圈舍详情
              {
                path: 'colonyHouse/info/:id?',
                name: `digitalLivestock-pigFarm-base-pigHouseInfo`,
                meta: {
                  title: '圈舍信息 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-base-pigHouseInfo']
                },
                component: () => import('@/view/pigFarm/pigHouse/pigHouseInfo')
              },
              // 养殖人员列表
              {
                path: 'user/list',
                name: `digitalLivestock-pigFarm-base-userList`,
                meta: {
                  title: '养殖人员',
                  access: ['digitalLivestock-pigFarm-base-userList']
                },
                component: () => import('@/view/pigFarm/pigUser/pigUserList')
              },
              // 养殖人员编辑
              {
                path: 'user/edit/:id?',
                name: `digitalLivestock-pigFarm-base-userEdit`,
                meta: {
                  title: '养殖人员 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-base-userEdit']
                },
                component: () => import('@/view/pigFarm/pigUser/pigUserEdit')
              },
              // 养殖人员查看
              {
                path: 'user/info/:id?',
                name: `digitalLivestock-pigFarm-base-userInfo`,
                meta: {
                  title: '养殖人员 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-base-userInfo']
                },
                component: () => import('@/view/pigFarm/pigUser/pigUserInfo')
              },
              // 人员排班
              {
                path: 'pigDuty/edit',
                name: `digitalLivestock-pigFarm-base-pigDutyEdit`,
                meta: {
                  title: '人员排班',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-base-pigDutyEdit']
                },
                component: () => import('@/view/pigFarm/pigDuty/pigDutyEdit')
              },
              // 畜禽信息列表
              {
                path: 'pigInfo/list',
                name: `digitalLivestock-pigFarm-base-pigInfoList`,
                meta: {
                  title: '畜禽信息',
                  access: ['digitalLivestock-pigFarm-base-pigInfoList']
                },
                component: () => import('@/view/pigFarm/pigInfo/pigInfoList')
              },
              // 畜禽信息编辑
              {
                path: 'pigInfo/edit/:id?',
                name: `digitalLivestock-pigFarm-base-pigInfoEdit`,
                meta: {
                  title: '畜禽信息 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-base-pigInfoEdit']
                },
                component: () => import('@/view/pigFarm/pigInfo/pigInfoEdit')
              },
              // 畜禽信息查看
              {
                path: 'pigInfo/info/:id?',
                name: `digitalLivestock-pigFarm-base-pigInfoInfo`,
                meta: {
                  title: '畜禽信息 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-base-pigInfoInfo']
                },
                component: () => import('@/view/pigFarm/pigInfo/pigInfoInfo')
              },
              // 畜禽转舍
              {
                path: 'pigTransfer/list',
                name: `digitalLivestock-pigFarm-base-pigTransferList`,
                meta: {
                  title: '畜禽转舍',
                  access: ['digitalLivestock-pigFarm-base-pigTransferList']
                },
                component: () => import('@/view/pigFarm/pigTransfer/pigTransferList')
              },
              // 畜禽转舍 添加
              {
                path: 'pigTransfer/edit/:id?',
                name: `digitalLivestock-pigFarm-base-pigTransferEdit`,
                meta: {
                  title: '畜禽转舍 添加',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-base-pigTransferEdit']
                },
                component: () => import('@/view/pigFarm/pigTransfer/pigTransferEdit')
              },
              // 畜禽转舍 查看
              {
                path: 'pigTransfer/info/:id?',
                name: `digitalLivestock-pigFarm-base-pigTransferInfo`,
                meta: {
                  title: '畜禽转舍 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-base-pigTransferInfo']
                },
                component: () => import('@/view/pigFarm/pigTransfer/pigTransferInfo')
              },
            ]
          },
          // 繁育管理
          {
            path: 'breeding',
            name: `digitalLivestock-pigFarm-breeding`,
            meta: {
              title: '繁育管理',
              access: ['digitalLivestock-pigFarm-breeding']
            },
            component: parentView,
            children: [
              // 繁育存栏
              {
                path: 'pigBreedInfo/list',
                name: `digitalLivestock-pigFarm-breeding-pigBreedInfoList`,
                meta: {
                  title: '繁育存栏',
                  access: ['digitalLivestock-pigFarm-breeding-pigBreedInfoList']
                },
                component: () => import('@/view/pigFarm/pigBreedInfo/pigBreedInfoList')
              },
              // 繁育存栏 添加/编辑
              {
                path: 'pigBreedInfo/edit/:id?',
                name: `digitalLivestock-pigFarm-breeding-pigBreedInfoEdit`,
                meta: {
                  title: '繁育存栏 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-breeding-pigBreedInfoEdit']
                },
                component: () => import('@/view/pigFarm/pigBreedInfo/pigBreedInfoEdit')
              },
              // 繁育存栏 查看
              {
                path: 'pigBreedInfo/info/:id?',
                name: `digitalLivestock-pigFarm-breeding-pigBreedInfoInfo`,
                meta: {
                  title: '繁育存栏 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-breeding-pigBreedInfoInfo']
                },
                component: () => import('@/view/pigFarm/pigBreedInfo/pigBreedInfoInfo')
              },
              // 配种记录
              {
                path: 'pigBreedCopulation/list',
                name: `digitalLivestock-pigFarm-breeding-pigBreedCopulationList`,
                meta: {
                  title: '配种记录',
                  access: ['digitalLivestock-pigFarm-breeding-pigBreedCopulationList']
                },
                component: () => import('@/view/pigFarm/pigBreedCopulation/pigBreedCopulationList')
              },
              // 配种记录 添加/编辑
              {
                path: 'pigBreedCopulation/edit/:id?',
                name: `digitalLivestock-pigFarm-breeding-pigBreedCopulationEdit`,
                meta: {
                  title: '配种记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-breeding-pigBreedCopulationEdit']
                },
                component: () => import('@/view/pigFarm/pigBreedCopulation/pigBreedCopulationEdit')
              },
              // 配种记录 查看
              {
                path: 'pigBreedCopulation/info/:id?',
                name: `digitalLivestock-pigFarm-breeding-pigBreedCopulationInfo`,
                meta: {
                  title: '配种记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-breeding-pigBreedCopulationInfo']
                },
                component: () => import('@/view/pigFarm/pigBreedCopulation/pigBreedCopulationInfo')
              },
              // 繁育记录
              {
                path: 'pigBreedLog/list',
                name: `digitalLivestock-pigFarm-breeding-pigBreedLogList`,
                meta: {
                  title: '繁育记录',
                  access: ['digitalLivestock-pigFarm-breeding-pigBreedLogList']
                },
                component: () => import('@/view/pigFarm/pigBreedLog/pigBreedLogList')
              },
              // 繁育记录 添加/编辑
              {
                path: 'pigBreedLog/edit/:id?',
                name: `digitalLivestock-pigFarm-breeding-pigBreedLogEdit`,
                meta: {
                  title: '繁育记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-breeding-pigBreedLogEdit']
                },
                component: () => import('@/view/pigFarm/pigBreedLog/pigBreedLogEdit')
              },
              // 繁育记录 查看
              {
                path: 'pigBreedLog/info/:id?',
                name: `digitalLivestock-pigFarm-breeding-pigBreedLogInfo`,
                meta: {
                  title: '繁育记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-breeding-pigBreedLogInfo']
                },
                component: () => import('@/view/pigFarm/pigBreedLog/pigBreedLogInfo')
              }
            ]
          },
          // 仔猪管理
          {
            path: 'pigChild',
            name: `digitalLivestock-pigFarm-pigChild`,
            meta: {
              title: '仔猪管理',
              access: ['digitalLivestock-pigFarm-pigChild']
            },
            component: parentView,
            children: [
              // 仔猪记录
              {
                path: 'pigChildInfo/list',
                name: `digitalLivestock-pigFarm-pigChild-pigChildInfoList`,
                meta: {
                  title: '仔猪记录',
                  access: ['digitalLivestock-pigFarm-pigChild-pigChildInfoList']
                },
                component: () => import('@/view/pigFarm/pigChildInfo/pigChildInfoList')
              },
              // 仔猪记录 添加/编辑
              {
                path: 'pigChildInfo/edit/:id?',
                name: `digitalLivestock-pigFarm-pigChild-pigChildInfoEdit`,
                meta: {
                  title: '仔猪记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-pigChild-pigChildInfoEdit']
                },
                component: () => import('@/view/pigFarm/pigChildInfo/pigChildInfoEdit')
              },
              // 仔猪记录 查看
              {
                path: 'pigChildInfo/info/:id?',
                name: `digitalLivestock-pigFarm-pigChild-pigChildInfoInfo`,
                meta: {
                  title: '仔猪记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-pigChild-pigChildInfoInfo']
                },
                component: () => import('@/view/pigFarm/pigChildInfo/pigChildInfoInfo')
              },

              // 仔猪出栏
              {
                path: 'pigChildOut/list',
                name: `digitalLivestock-pigFarm-pigChild-pigChildOutList`,
                meta: {
                  title: '仔猪出栏',
                  access: ['digitalLivestock-pigFarm-pigChild-pigChildOutList']
                },
                component: () => import('@/view/pigFarm/pigChildOut/pigChildOutList')
              },
              // 仔猪出栏 添加/编辑
              {
                path: 'pigChildOut/edit/:id?',
                name: `digitalLivestock-pigFarm-pigChild-pigChildOutEdit`,
                meta: {
                  title: '仔猪出栏 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-pigChild-pigChildOutEdit']
                },
                component: () => import('@/view/pigFarm/pigChildOut/pigChildOutEdit')
              },
              // 仔猪出栏 查看
              {
                path: 'pigChildOut/info/:id?',
                name: `digitalLivestock-pigFarm-pigChild-pigChildOutInfo`,
                meta: {
                  title: '仔猪出栏 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-pigChild-pigChildOutInfo']
                },
                component: () => import('@/view/pigFarm/pigChildOut/pigChildOutInfo')
              },

              // 仔猪转舍
              {
                path: 'pigChildTransfer/list',
                name: `digitalLivestock-pigFarm-pigChild-pigChildTransferList`,
                meta: {
                  title: '仔猪转舍',
                  access: ['digitalLivestock-pigFarm-pigChild-pigChildTransferList']
                },
                component: () => import('@/view/pigFarm/pigChildTransfer/pigChildTransferList')
              },
              // 仔猪转舍 添加
              {
                path: 'pigChildTransfer/edit/:id?',
                name: `digitalLivestock-pigFarm-pigChild-pigChildTransferEdit`,
                meta: {
                  title: '仔猪转舍 添加',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-pigChild-pigChildTransferEdit']
                },
                component: () => import('@/view/pigFarm/pigChildTransfer/pigChildTransferEdit')
              }
            ]
          },
          // 饲料管理
          {
            path: 'fodderManage',
            name: `digitalLivestock-pigFarm-fodderManage`,
            meta: {
              title: '饲料管理',
              access: ['digitalLivestock-pigFarm-fodderManage']
            },
            component: parentView,
            children: [
              // 库存记录
              {
                path: 'pigFodder/list',
                name: `digitalLivestock-pigFarm-fodderManage-pigFodderList`,
                meta: {
                  title: '库存记录',
                  access: ['digitalLivestock-pigFarm-fodderManage-pigFodderList']
                },
                component: () => import('@/view/pigFarm/pigFodder/pigFodderList')
              },
              // 库存记录 添加/编辑
              {
                path: 'pigFodder/edit/:id?',
                name: `digitalLivestock-pigFarm-fodderManage-pigFodderEdit`,
                meta: {
                  title: '库存记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-fodderManage-pigFodderEdit']
                },
                component: () => import('@/view/pigFarm/pigFodder/pigFodderEdit')
              },
              // 库存记录 查看
              {
                path: 'pigFodder/info/:id?',
                name: `digitalLivestock-pigFarm-fodderManage-pigFodderInfo`,
                meta: {
                  title: '库存记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-fodderManage-pigFodderInfo']
                },
                component: () => import('@/view/pigFarm/pigFodder/pigFodderInfo')
              },
              // 投放记录
              {
                path: 'pigFodderLog/list',
                name: `digitalLivestock-pigFarm-fodderManage-pigFodderLogList`,
                meta: {
                  title: '投放记录',
                  access: ['digitalLivestock-pigFarm-fodderManage-pigFodderLogList']
                },
                component: () => import('@/view/pigFarm/pigFodderLog/pigFodderLogList')
              },
              // 投放记录 添加/编辑
              {
                path: 'pigFodderLog/edit/:id?',
                name: `digitalLivestock-pigFarm-fodderManage-pigFodderLogEdit`,
                meta: {
                  title: '投放记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-fodderManage-pigFodderLogEdit']
                },
                component: () => import('@/view/pigFarm/pigFodderLog/pigFodderLogEdit')
              },
              // 投放记录 查看
              {
                path: 'pigFodderLog/info/:id?',
                name: `digitalLivestock-pigFarm-fodderManage-pigFodderLogInfo`,
                meta: {
                  title: '投放记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-fodderManage-pigFodderLogInfo']
                },
                component: () => import('@/view/pigFarm/pigFodderLog/pigFodderLogInfo')
              }
            ]
          },
          // 出栏管理
          {
            path: 'outManage',
            name: `digitalLivestock-pigFarm-outManage`,
            meta: {
              title: '出栏管理',
              access: ['digitalLivestock-pigFarm-outManage']
            },
            component: parentView,
            children: [
              // 出栏记录
              {
                path: 'pigOut/list',
                name: `digitalLivestock-pigFarm-outManage-pigOutList`,
                meta: {
                  title: '出栏记录',
                  access: ['digitalLivestock-pigFarm-outManage-pigOutList']
                },
                component: () => import('@/view/pigFarm/pigOut/pigOutList')
              },
              // 出栏记录 添加/编辑
              {
                path: 'pigOut/edit/:id?',
                name: `digitalLivestock-pigFarm-outManage-pigOutEdit`,
                meta: {
                  title: '出栏记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-outManage-pigOutEdit']
                },
                component: () => import('@/view/pigFarm/pigOut/pigOutEdit')
              },
              // 出栏记录 查看
              {
                path: 'pigOut/info/:id?',
                name: `digitalLivestock-pigFarm-outManage-pigOutInfo`,
                meta: {
                  title: '出栏记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-outManage-pigOutInfo']
                },
                component: () => import('@/view/pigFarm/pigOut/pigOutInfo')
              }
            ]
          },
          // 屠宰管理
          {
            path: 'slaughterManage',
            name: `digitalLivestock-pigFarm-slaughterManage`,
            meta: {
              title: '屠宰管理',
              access: ['digitalLivestock-pigFarm-slaughterManage']
            },
            component: parentView,
            children: [
              // 静养圈管理 pigSlaughterRest
              {
                path: 'pigSlaughterRest/list',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterRestList`,
                meta: {
                  title: '静养圈管理',
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterRestList']
                },
                component: () => import('@/view/pigFarm/pigSlaughterRest/pigSlaughterRestList')
              },
              // 静养圈管理 添加/编辑
              {
                path: 'pigSlaughterRest/edit/:id?',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterRestEdit`,
                meta: {
                  title: '静养圈管理 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterRestEdit']
                },
                component: () => import('@/view/pigFarm/pigSlaughterRest/pigSlaughterRestEdit')
              },
              // 静养圈管理 查看
              {
                path: 'pigSlaughterRest/info/:id?',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterRestInfo`,
                meta: {
                  title: '静养圈管理 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterRestInfo']
                },
                component: () => import('@/view/pigFarm/pigSlaughterRest/pigSlaughterRestInfo')
              },

              // 检疫记录
              {
                path: 'pigSlaughterQuarantine/list',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterQuarantineList`,
                meta: {
                  title: '检疫记录',
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterQuarantineList']
                },
                component: () => import('@/view/pigFarm/pigSlaughterQuarantine/pigSlaughterQuarantineList')
              },
              // 检疫记录 添加/编辑
              {
                path: 'pigSlaughterQuarantine/edit/:id?',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterQuarantineEdit`,
                meta: {
                  title: '检疫记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterQuarantineEdit']
                },
                component: () => import('@/view/pigFarm/pigSlaughterQuarantine/pigSlaughterQuarantineEdit')
              },
              // 检疫记录 查看
              {
                path: 'pigSlaughterQuarantine/info/:id?',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterQuarantineInfo`,
                meta: {
                  title: '检疫记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterQuarantineInfo']
                },
                component: () => import('@/view/pigFarm/pigSlaughterQuarantine/pigSlaughterQuarantineInfo')
              },

              // 屠宰记录
              {
                path: 'pigSlaughterLog/list',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterLogList`,
                meta: {
                  title: '屠宰记录',
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterLogList']
                },
                component: () => import('@/view/pigFarm/pigSlaughterLog/pigSlaughterLogList')
              },

              // 屠宰记录 添加/编辑
              {
                path: 'pigSlaughterLog/edit/:id?',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterLogEdit`,
                meta: {
                  title: '屠宰记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterLogEdit']
                },
                component: () => import('@/view/pigFarm/pigSlaughterLog/pigSlaughterLogEdit')
              },
              // 屠宰记录 查看
              {
                path: 'pigSlaughterLog/info/:id?',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterLogInfo`,
                meta: {
                  title: '屠宰记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterLogInfo']
                },
                component: () => import('@/view/pigFarm/pigSlaughterLog/pigSlaughterLogInfo')
              },

              // 出场记录 pigSlaughterSalesLog
              {
                path: 'pigSlaughterSalesLog/list',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterSalesLogList`,
                meta: {
                  title: '出场记录',
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterSalesLogList']
                },
                component: () => import('@/view/pigFarm/pigSlaughterSalesLog/pigSlaughterSalesLogList')
              },
              // 出场记录 添加/编辑
              {
                path: 'pigSlaughterSalesLog/edit/:id?',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterSalesLogEdit`,
                meta: {
                  title: '出场记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterSalesLogEdit']
                },
                component: () => import('@/view/pigFarm/pigSlaughterSalesLog/pigSlaughterSalesLogEdit')
              },
              // 出场记录 查看
              {
                path: 'pigSlaughterSalesLog/info/:id?',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterSalesLogInfo`,
                meta: {
                  title: '出场记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterSalesLogInfo']
                },
                component: () => import('@/view/pigFarm/pigSlaughterSalesLog/pigSlaughterSalesLogInfo')
              },

              // 经销商管理
              {
                path: 'pigSlaughterSales/list',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterSalesList`,
                meta: {
                  title: '经销商管理',
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterSalesList']
                },
                component: () => import('@/view/pigFarm/pigSlaughterSales/pigSlaughterSalesList')
              },
              // 经销商管理 添加/编辑
              {
                path: 'pigSlaughterSales/edit/:id?',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterSalesEdit`,
                meta: {
                  title: '经销商管理 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterSalesEdit']
                },
                component: () => import('@/view/pigFarm/pigSlaughterSales/pigSlaughterSalesEdit')
              },
              // 经销商管理 查看
              {
                path: 'pigSlaughterSales/info/:id?',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterSalesInfo`,
                meta: {
                  title: '经销商管理 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterSalesInfo']
                },
                component: () => import('@/view/pigFarm/pigSlaughterSales/pigSlaughterSalesInfo')
              },
              // 屠宰场管理
              {
                path: 'pigSlaughter/list',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterList`,
                meta: {
                  title: '屠宰场管理',
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterList']
                },
                component: () => import('@/view/pigFarm/pigSlaughter/pigSlaughterList')
              },
              // 屠宰场管理 添加/编辑
              {
                path: 'pigSlaughter/edit/:id?',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterEdit`,
                meta: {
                  title: '屠宰场管理 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterEdit']
                },
                component: () => import('@/view/pigFarm/pigSlaughter/pigSlaughterEdit')
              },
              // 屠宰场管理 查看
              {
                path: 'pigSlaughter/info/:id?',
                name: `digitalLivestock-pigFarm-slaughterManage-pigSlaughterInfo`,
                meta: {
                  title: '屠宰场管理 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-slaughterManage-pigSlaughterInfo']
                },
                component: () => import('@/view/pigFarm/pigSlaughter/pigSlaughterInfo')
              }
            ]
          },

          // 畜禽防疫
          {
            path: 'prevention',
            name: `digitalLivestock-pigFarm-prevention`,
            meta: {
              title: '畜禽防疫',
              access: ['digitalLivestock-pigFarm-prevention']
            },
            component: parentView,
            children: [
              // 接种记录
              {
                path: 'pigInoculate/list',
                name: `digitalLivestock-pigFarm-prevention-pigInoculateList`,
                meta: {
                  title: '接种记录',
                  access: ['digitalLivestock-pigFarm-prevention-pigInoculateList']
                },
                component: () => import('@/view/pigFarm/pigInoculate/pigInoculateList')
              },
              // 接种记录 添加/编辑
              {
                path: 'pigInoculate/edit/:id?',
                name: `digitalLivestock-pigFarm-prevention-pigInoculateEdit`,
                meta: {
                  title: '接种记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-prevention-pigInoculateEdit']
                },
                component: () => import('@/view/pigFarm/pigInoculate/pigInoculateEdit')
              },
              // 接种记录 查看
              {
                path: 'pigInoculate/info/:id?',
                name: `digitalLivestock-pigFarm-prevention-pigInoculateInfo`,
                meta: {
                  title: '接种记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-prevention-pigInoculateInfo']
                },
                component: () => import('@/view/pigFarm/pigInoculate/pigInoculateInfo')
              },

              // 用药记录
              {
                path: 'pigMedicine/list',
                name: `digitalLivestock-pigFarm-prevention-pigMedicineList`,
                meta: {
                  title: '用药记录',
                  access: ['digitalLivestock-pigFarm-prevention-pigMedicineList']
                },
                component: () => import('@/view/pigFarm/pigMedicine/pigMedicineList')
              },
              // 用药记录 添加/编辑
              {
                path: 'pigMedicine/edit/:id?',
                name: `digitalLivestock-pigFarm-prevention-pigMedicineEdit`,
                meta: {
                  title: '用药记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-prevention-pigMedicineEdit']
                },
                component: () => import('@/view/pigFarm/pigMedicine/pigMedicineEdit')
              },
              // 用药记录 查看
              {
                path: 'pigMedicine/info/:id?',
                name: `digitalLivestock-pigFarm-prevention-pigMedicineInfo`,
                meta: {
                  title: '用药记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-prevention-pigMedicineInfo']
                },
                component: () => import('@/view/pigFarm/pigMedicine/pigMedicineInfo')
              },

              // 佩标记录
              {
                path: 'pigWearTag/list',
                name: `digitalLivestock-pigFarm-prevention-pigWearTagList`,
                meta: {
                  title: '佩标记录',
                  access: ['digitalLivestock-pigFarm-prevention-pigWearTagList']
                },
                component: () => import('@/view/pigFarm/pigWearTag/pigWearTagList')
              },

              // 防疫检疫
              {
                path: 'pigQuarantine/list',
                name: `digitalLivestock-pigFarm-prevention-pigQuarantineList`,
                meta: {
                  title: '防疫检疫',
                  access: ['digitalLivestock-pigFarm-prevention-pigQuarantineList']
                },
                component: () => import('@/view/pigFarm/pigQuarantine/pigQuarantineList')
              },
              // 防疫检疫 添加/编辑
              {
                path: 'pigQuarantine/edit/:id?',
                name: `digitalLivestock-pigFarm-prevention-pigQuarantineEdit`,
                meta: {
                  title: '防疫检疫 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-prevention-pigQuarantineEdit']
                },
                component: () => import('@/view/pigFarm/pigQuarantine/pigQuarantineEdit')
              },
              // 防疫检疫 查看
              {
                path: 'pigQuarantine/info/:id?',
                name: `digitalLivestock-pigFarm-prevention-pigQuarantineInfo`,
                meta: {
                  title: '防疫检疫 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-prevention-pigQuarantineInfo']
                },
                component: () => import('@/view/pigFarm/pigQuarantine/pigQuarantineInfo')
              }
            ]
          },

          // 无害化管理
          {
            path: 'harmless',
            name: `digitalLivestock-pigFarm-harmless`,
            meta: {
              title: '无害化管理',
              access: ['digitalLivestock-pigFarm-harmless']
            },
            component: parentView,
            children: [
              // 死亡登记
              {
                path: 'pigHarmlessDeath/list',
                name: `digitalLivestock-pigFarm-harmless-pigHarmlessDeathList`,
                meta: {
                  title: '死亡登记',
                  access: ['digitalLivestock-pigFarm-harmless-pigHarmlessDeathList']
                },
                component: () => import('@/view/pigFarm/pigHarmlessDeath/pigHarmlessDeathList')
              },
              // 死亡登记 添加/编辑
              {
                path: 'pigHarmlessDeath/edit/:id?',
                name: `digitalLivestock-pigFarm-harmless-pigHarmlessDeathEdit`,
                meta: {
                  title: '死亡登记 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-harmless-pigHarmlessDeathEdit']
                },
                component: () => import('@/view/pigFarm/pigHarmlessDeath/pigHarmlessDeathEdit')
              },
              // 死亡登记 查看
              {
                path: 'pigHarmlessDeath/info/:id?',
                name: `digitalLivestock-pigFarm-harmless-pigHarmlessDeathInfo`,
                meta: {
                  title: '死亡登记 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-harmless-pigHarmlessDeathInfo']
                },
                component: () => import('@/view/pigFarm/pigHarmlessDeath/pigHarmlessDeathInfo')
              },

              // 收集记录
              {
                path: 'pigHarmlessCollect/list',
                name: `digitalLivestock-pigFarm-harmless-pigHarmlessCollectList`,
                meta: {
                  title: '收集记录',
                  access: ['digitalLivestock-pigFarm-harmless-pigHarmlessCollectList']
                },
                component: () => import('@/view/pigFarm/pigHarmlessCollect/pigHarmlessCollectList')
              },
              // 收集记录 添加/编辑
              {
                path: 'pigHarmlessCollect/edit/:id?',
                name: `digitalLivestock-pigFarm-harmless-pigHarmlessCollectEdit`,
                meta: {
                  title: '收集记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-harmless-pigHarmlessCollectEdit']
                },
                component: () => import('@/view/pigFarm/pigHarmlessCollect/pigHarmlessCollectEdit')
              },
              // 收集记录 查看
              {
                path: 'pigHarmlessCollect/info/:id?',
                name: `digitalLivestock-pigFarm-harmless-pigHarmlessCollectInfo`,
                meta: {
                  title: '收集记录 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-harmless-pigHarmlessCollectInfo']
                },
                component: () => import('@/view/pigFarm/pigHarmlessCollect/pigHarmlessCollectInfo')
              },

              // 无害化处理
              {
                path: 'pigHarmlessInfo/list',
                name: `digitalLivestock-pigFarm-harmless-pigHarmlessInfoList`,
                meta: {
                  title: '无害化处理',
                  access: ['digitalLivestock-pigFarm-harmless-pigHarmlessInfoList']
                },
                component: () => import('@/view/pigFarm/pigHarmlessInfo/pigHarmlessInfoList')
              },
              // 无害化处理 添加/编辑
              {
                path: 'pigHarmlessInfo/edit/:id?',
                name: `digitalLivestock-pigFarm-harmless-pigHarmlessInfoEdit`,
                meta: {
                  title: '无害化处理 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-harmless-pigHarmlessInfoEdit']
                },
                component: () => import('@/view/pigFarm/pigHarmlessInfo/pigHarmlessInfoEdit')
              },
              // 无害化处理 查看
              {
                path: 'pigHarmlessInfo/info/:id?',
                name: `digitalLivestock-pigFarm-harmless-pigHarmlessInfoInfo`,
                meta: {
                  title: '无害化处理 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-harmless-pigHarmlessInfoInfo']
                },
                component: () => import('@/view/pigFarm/pigHarmlessInfo/pigHarmlessInfoInfo')
              },

              // 保险理赔
              {
                path: 'pigHarmlessInsurance/list',
                name: `digitalLivestock-pigFarm-harmless-pigHarmlessInsuranceList`,
                meta: {
                  title: '保险理赔',
                  access: ['digitalLivestock-pigFarm-harmless-pigHarmlessInsuranceList']
                },
                component: () => import('@/view/pigFarm/pigHarmlessInsurance/pigHarmlessInsuranceList')
              },
              // 保险理赔 添加/编辑
              {
                path: 'pigHarmlessInsurance/edit/:id?',
                name: `digitalLivestock-pigFarm-harmless-pigHarmlessInsuranceEdit`,
                meta: {
                  title: '保险理赔 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-harmless-pigHarmlessInsuranceEdit']
                },
                component: () => import('@/view/pigFarm/pigHarmlessInsurance/pigHarmlessInsuranceEdit')
              },
              // 保险理赔 查看
              {
                path: 'pigHarmlessInsurance/info/:id?',
                name: `digitalLivestock-pigFarm-harmless-pigHarmlessInsuranceInfo`,
                meta: {
                  title: '保险理赔 查看',
                  hideInMenu: true,
                  access: ['digitalLivestock-pigFarm-harmless-pigHarmlessInsuranceInfo']
                },
                component: () => import('@/view/pigFarm/pigHarmlessInsurance/pigHarmlessInsuranceInfo')
              }
            ]
          },

          // 设备管理
          {
            path: 'device',
            name: `digitalLivestock-pigFarm-device`,
            meta: {
              title: '设备管理',
              access: ['digitalLivestock-pigFarm-device']
            },
            component: parentView,
            children: [
              // 环境设备
              {
                path: 'pigDeviceEnvironment/list',
                name: `digitalLivestock-pigFarm-device-pigDeviceEnvironmentList`,
                meta: {
                  title: '环境设备',
                  access: ['digitalLivestock-pigFarm-device-pigDeviceEnvironmentList']
                },
                component: () => import('@/view/pigFarm/pigDevice/pigDeviceEnvironmentList')
              },
              // 环境设备 历史记录
              {
                path: 'pigDeviceEnvironment/log/list/:id?',
                name: `digitalLivestock-pigFarm-device-pigDeviceEnvironmentLogList`,
                meta: {
                  title: '环境设备 历史记录',
                  hideInMenu: true, // 菜单栏不显示
                  access: ['digitalLivestock-pigFarm-device-pigDeviceEnvironmentLogList']
                },
                component: () => import('@/view/pigFarm/pigDevice/pigDeviceEnvironmentLogList')
              },
              // 监控设备
              {
                path: 'pigDeviceMonitoring/list',
                name: `digitalLivestock-pigFarm-device-pigDeviceMonitoringList`,
                meta: {
                  title: '监控设备',
                  access: ['digitalLivestock-pigFarm-device-pigDeviceMonitoringList']
                },
                component: () => import('@/view/pigFarm/pigDevice/pigDeviceMonitoringList')
              }

            ]
          }
        ]
      }
    ]
  },

  // 数字加工管理
  {
    path: '/admin/digitalMachining',
    name: `digitalMachining`,
    meta: {
      title: '加工溯源管理',
      icon: 'md-list-box',
      access: ['digitalMachining']
    },
    component: Main,
    children: [
      // 生产加工
      {
        path: 'processing',
        name: `digitalMachining-processing`,
        meta: {
          title: '生产加工',
          access: ['digitalMachining-processing']
        },
        component: parentView,
        children: [
          // 加工记录
          {
            path: 'production/list',
            name: 'digitalMachining-processing-productionList',
            meta: {
              title: '加工记录',
              access: ['digitalMachining-processing-productionList']
            },
            component: () => import('@/view/processing/processing/production/productionList')
          },
          // 加工记录 添加/编辑
          {
            path: 'production/edit/:id?',
            name: `digitalMachining-processing-productionEdit`,
            meta: {
              title: '加工记录 添加/编辑',
              hideInMenu: true,
              access: ['digitalMachining-processing-productionEdit']
            },
            component: () => import('@/view/processing/processing/production/productionEdit')
          },
          // 加工记录 查看
          {
            path: 'production/info/:id?',
            name: `digitalMachining-processing-productionInfo`,
            meta: {
              title: '加工记录 查看',
              hideInMenu: true,
              access: ['digitalMachining-processing-productionInfo']
            },
            component: () => import('@/view/processing/processing/production/productionInfo')
          },
          // 包装记录
          {
            path: 'packing/list',
            name: 'digitalMachining-processing-packingList',
            meta: {
              title: '包装记录',
              access: ['digitalMachining-processing-packingList']
            },
            component: () => import('@/view/processing/processing/packing/packingList')
          },
          // 包装记录 添加/编辑
          {
            path: 'packing/edit/:id?',
            name: `digitalMachining-processing-packingEdit`,
            meta: {
              title: '包装记录 添加/编辑',
              hideInMenu: true,
              access: ['digitalMachining-processing-packingEdit']
            },
            component: () => import('@/view/processing/processing/packing/packingEdit')
          },
          // 包装记录 查看
          {
            path: 'packing/info/:id?',
            name: `digitalMachining-processing-packingInfo`,
            meta: {
              title: '包装记录 查看',
              hideInMenu: true,
              access: ['digitalMachining-processing-packingInfo']
            },
            component: () => import('@/view/processing/processing/packing/packingInfo')
          },
          // 成品销售
          {
            path: 'productionSale/list',
            name: 'digitalMachining-processing-productionSaleList',
            meta: {
              title: '成品销售',
              access: ['digitalMachining-processing-productionSaleList']
            },
            component: () => import('@/view/processing/processing/productionSale/productionSaleList')
          },
          // 成品销售 添加/编辑
          {
            path: 'productionSale/edit/:id?',
            name: `digitalMachining-processing-productionSaleEdit`,
            meta: {
              title: '成品销售 添加/编辑',
              hideInMenu: true,
              access: ['digitalMachining-processing-productionSaleEdit']
            },
            component: () => import('@/view/processing/processing/productionSale/productionSaleEdit')
          },
          // 成品销售 查看
          {
            path: 'productionSale/info/:id?',
            name: `digitalMachining-processing-productionSaleInfo`,
            meta: {
              title: '成品销售 查看',
              hideInMenu: true,
              access: ['digitalMachining-processing-productionSaleInfo']
            },
            component: () => import('@/view/processing/processing/productionSale/productionSaleInfo')
          },
          // 加工商信息
          {
            path: 'processingCompany/list',
            name: 'digitalMachining-processing-processingCompanyList',
            meta: {
              title: '加工商信息',
              access: ['digitalMachining-processing-processingCompanyList']
            },
            component: () => import('@/view/processing/processing/processingCompany/processingCompanyList')
          },
          // 加工商信息 添加/编辑
          {
            path: 'processingCompany/edit/:id?',
            name: `digitalMachining-processing-processingCompanyEdit`,
            meta: {
              title: '加工商信息 添加/编辑',
              hideInMenu: true,
              access: ['digitalMachining-processing-processingCompanyEdit']
            },
            component: () => import('@/view/processing/processing/processingCompany/processingCompanyEdit')
          },
          // 加工商信息 查看
          {
            path: 'processingCompany/info/:id?',
            name: `digitalMachining-processing-processingCompanyInfo`,
            meta: {
              title: '加工商信息 查看',
              hideInMenu: true,
              access: ['digitalMachining-processing-processingCompanyInfo']
            },
            component: () => import('@/view/processing/processing/processingCompany/processingCompanyInfo')
          }

        ]
      },
      // 质量管理
      {
        path: 'quality',
        name: 'digitalMachining-quality',
        meta: {
          title: '质量管理',
          access: ['digitalMachining-quality']
        },
        component: parentView,
        children: [
          // 制度管理
          {
            path: 'systems',
            name: 'digitalMachining-quality-systems',
            meta: {
              title: '制度管理',
              access: ['digitalMachining-quality-systems']
            },
            component: parentView,
            children: [
              // 制度信息
              {
                path: 'systems/list',
                name: 'digitalMachining-quality-systems-systemsList',
                meta: {
                  title: '制度信息',
                  access: ['digitalMachining-quality-systems-systemsList']
                },
                component: () => import('@/view/processing/quality/qualitySystems/qualitySystemsList')
              },
              // 制度信息 添加/编辑
              {
                path: 'systems/edit/:id?',
                name: 'digitalMachining-quality-systems-systemsEdit',
                meta: {
                  title: '制度信息 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalMachining-quality-systems-systemsEdit']
                },
                component: () => import('@/view/processing/quality/qualitySystems/qualitySystemsEdit')
              },
              // 制度信息 查看
              {
                path: 'systems/info/:id',
                name: 'digitalMachining-quality-systems-systemsInfo',
                meta: {
                  title: '制度信息 查看',
                  hideInMenu: true,
                  access: ['digitalMachining-quality-systems-systemsInfo']
                },
                component: () => import('@/view/processing/quality/qualitySystems/qualitySystemsInfo')
              },
              // 制度细项
              {
                path: 'systemsItems/list',
                name: 'digitalMachining-quality-systems-systemsItemsList',
                meta: {
                  title: '制度细项',
                  access: ['digitalMachining-quality-systems-systemsItemsList']
                },
                component: () => import('@/view/processing/quality/qualitySystemItems/qualitySystemItemsList')
              },
              // 制度细项 添加/编辑
              {
                path: 'systemsItems/edit/:id?',
                name: 'digitalMachining-quality-systems-systemsItemsEdit',
                meta: {
                  title: '制度细项 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalMachining-quality-systems-systemsItemsEdit']
                },
                component: () => import('@/view/processing/quality/qualitySystemItems/qualitySystemItemsEdit')
              },
              // 制度细项 查看
              {
                path: 'systemsItems/info/:id',
                name: 'digitalMachining-quality-systems-systemsItemsInfo',
                meta: {
                  title: '制度细项 查看',
                  hideInMenu: true,
                  access: ['digitalMachining-quality-systems-systemsItemsInfo']
                },
                component: () => import('@/view/processing/quality/qualitySystemItems/qualitySystemItemsInfo')
              },
            ]
          },

          // 检测管理
          {
            path: 'inspections',
            name: 'digitalMachining-quality-inspections',
            meta: {
              title: '检测管理',
              access: ['digitalMachining-quality-inspections']
            },
            component: parentView,
            children: [
              // 质量检测
              {
                path: 'inspections',
                name: 'digitalMachining-quality-inspections-inspections',
                meta: {
                  title: '质量检测',
                  access: ['digitalMachining-quality-inspections-inspections']
                },
                component: () => import('@/view/processing/quality/qualityInspections/qualityInspections')
              },
              // 检测记录
              {
                path: 'inspections/list',
                name: 'digitalMachining-quality-inspections-inspectionsList',
                meta: {
                  title: '检测记录',
                  access: ['digitalMachining-quality-inspections-inspectionsList']
                },
                component: () => import('@/view/processing/quality/qualityInspections/qualityInspectionsList')
              },
              // 检测记录 添加/编辑
              {
                path: 'inspections/edit/:id?',
                name: 'digitalMachining-quality-inspections-inspectionsEdit',
                meta: {
                  title: '检测记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalMachining-quality-inspections-inspectionsEdit']
                },
                component: () => import('@/view/processing/quality/qualityInspections/qualityInspectionsEdit')
              },
              // 检测记录 查看
              {
                path: 'inspections/info/:id',
                name: 'digitalMachining-quality-inspections-inspectionsInfo',
                meta: {
                  title: '检测记录 查看',
                  hideInMenu: true,
                  access: ['digitalMachining-quality-inspections-inspectionsInfo']
                },
                component: () => import('@/view/processing/quality/qualityInspections/qualityInspectionsInfo')
              },
            ]
          },

          // 认证管理
          {
            path: 'certifications',
            name: 'digitalMachining-quality-certifications',
            meta: {
              title: '认证管理',
              access: ['digitalMachining-quality-certifications']
            },
            component: parentView,
            children: [
              // 产品认证
              {
                path: 'certifications',
                name: 'digitalMachining-quality-certifications-certifications',
                meta: {
                  title: '产品认证',
                  access: ['digitalMachining-quality-certifications-certifications']
                },
                component: () => import('@/view/processing/quality/qualityCertifications/qualityCertifications')
              },
              // 认证记录
              {
                path: 'certifications/list',
                name: 'digitalMachining-quality-certifications-certificationsList',
                meta: {
                  title: '认证记录',
                  access: ['digitalMachining-quality-certifications-certificationsList']
                },
                component: () => import('@/view/processing/quality/qualityCertifications/qualityCertificationsList')
              },
              // 认证记录 添加/编辑
              {
                path: 'certifications/edit/:id?',
                name: 'digitalMachining-quality-certifications-certificationsEdit',
                meta: {
                  title: '认证记录 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalMachining-quality-certifications-certificationsEdit']
                },
                component: () => import('@/view/processing/quality/qualityCertifications/qualityCertificationsEdit')
              },
              // 认证记录 查看
              {
                path: 'certifications/info/:id',
                name: 'digitalMachining-quality-certifications-certificationsInfo',
                meta: {
                  title: '认证记录 查看',
                  hideInMenu: true,
                  access: ['digitalMachining-quality-certifications-certificationsInfo']
                },
                component: () => import('@/view/processing/quality/qualityCertifications/qualityCertificationsInfo')
              },
              // 认证类型
              {
                path: 'qualityCertificationsType/list',
                name: 'digitalMachining-quality-certifications-qualityCertificationsTypeList',
                meta: {
                  title: '认证类型',
                  access: ['digitalMachining-quality-certifications-qualityCertificationsTypeList']
                },
                component: () => import('@/view/processing/quality/qualityCertificationsType/qualityCertificationsTypeList')
              },
              // 认证类型 添加/编辑
              {
                path: 'qualityCertificationsType/edit/:id?',
                name: 'digitalMachining-quality-certifications-qualityCertificationsTypeEdit',
                meta: {
                  title: '认证类型 添加/编辑',
                  hideInMenu: true,
                  access: ['digitalMachining-quality-certifications-qualityCertificationsTypeEdit']
                },
                component: () => import('@/view/processing/quality/qualityCertificationsType/qualityCertificationsTypeEdit')
              },
              // 认证类型 查看
              {
                path: 'qualityCertificationsType/info/:id',
                name: 'digitalMachining-quality-certifications-qualityCertificationsTypeInfo',
                meta: {
                  title: '认证类型 查看',
                  hideInMenu: true,
                  access: ['digitalMachining-quality-certifications-qualityCertificationsTypeInfo']
                },
                component: () => import('@/view/processing/quality/qualityCertificationsType/qualityCertificationsTypeInfo')
              },


            ]
          },



        ]
      },
      // 溯源管理
      {
        path: 'traceability',
        name: `digitalMachining-traceability`,
        meta: {
          title: '溯源管理',
          access: ['digitalMachining-traceability']
        },
        component: parentView,
        children: [
          // 种植加工溯源
          {
            path: 'traceabilityCode/planting/list',
            name: 'digitalMachining-traceability-traceabilityCodePlantingList',
            meta: {
              title: '种植加工溯源',
              access: ['digitalMachining-traceability-traceabilityCodePlantingList']
            },
            component: () => import('@/view/processing/traceability/traceabilityCode/traceabilityCodePlantingList')
          },
          // 种植加工溯源 产品介绍
          {
            path: 'traceabilityCode/planting/edit/:id?',
            name: 'digitalMachining-traceability-traceabilityCodePlantingEdit',
            meta: {
              title: '种植加工溯源 产品介绍',
              hideInMenu: true,
              access: ['digitalMachining-traceability-traceabilityCodePlantingEdit']
            },
            component: () => import('@/view/processing/traceability/traceabilityCode/traceabilityCodePlantingEdit')
          },
          // 牛场出栏溯源
          {
            path: 'traceabilityCode/cattle/list',
            name: 'digitalMachining-traceability-traceabilityCodeCattleList',
            meta: {
              title: '牛场出栏溯源',
              access: ['digitalMachining-traceability-traceabilityCodeCattleList']
            },
            component: () => import('@/view/processing/traceability/traceabilityCode/traceabilityCodeCattleList')
          },
          // 猪场出栏溯源
          {
            path: 'traceabilityCode/pig/list',
            name: 'digitalMachining-traceability-traceabilityCodePigList',
            meta: {
              title: '猪场出栏溯源',
              access: ['digitalMachining-traceability-traceabilityCodePigList']
            },
            component: () => import('@/view/processing/traceability/traceabilityCode/traceabilityCodePigList')
          },
          // 溯源记录 列表
          {
            path: 'traceabilityLog/list',
            name: `digitalMachining-traceability-traceabilityLogList`,
            meta: {
              title: '溯源记录',
              access: ['digitalMachining-traceability-traceabilityLogList']
            },
            component: () => import('@/view/processing/traceability/traceabilityLog/traceabilityLogList')
          },

        ]
      },
    ],
  },

  // 数字仓储管理
  {
    path: '/admin/warehousing',
    name: `warehousing`,
    meta: {
      title: '数字仓储管理',
      icon: 'md-list-box',
      access: ['warehousing']
    },
    component: Main,
    children: [
      // 数据可视化
      {
        path: 'dataVisualization',
        name: `warehousing-dataVisualization`,
        meta: {
          title: '数据可视化',
          access: ['warehousing-dataVisualization']
        },
        component: () => import('@/view/warehouse/dataVisualization')
      },
      // 仓库管理
      {
        path: 'warehouse/list',
        name: `warehousing-warehouseList`,
        meta: {
          title: '仓库管理',
          access: ['warehousing-warehouseList']
        },
        component: () => import('@/view/warehouse/warehouse/warehouseList')
      },
      // 仓库信息 添加/编辑
      {
        path: 'warehouse/edit/:id?',
        name: `warehousing-warehouseEdit`,
        meta: {
          title: '仓库信息 添加/编辑',
          hideInMenu: true, // 菜单栏不显示
          access: ['warehousing-warehouseEdit']
        },
        component: () => import('@/view/warehouse/warehouse/warehouseEdit')
      },
      // 仓库信息 查看
      {
        path: 'warehouse/info/:id?',
        name: `warehousing-warehouseInfo`,
        meta: {
          title: '仓库信息 查看',
          hideInMenu: true, // 菜单栏不显示
          access: ['warehousing-warehouseInfo']
        },
        component: () => import('@/view/warehouse/warehouse/warehouseInfo')
      },
      // 仓库人员排班
      {
        path: 'warehouseDuty/edit',
        name: `warehousing-warehouseDutyEdit`,
        meta: {
          title: '人员排班',
          hideInMenu: true,
          access: ['warehousing-warehouseDutyEdit']
        },
        component: () => import('@/view/warehouse/warehouseDuty/warehouseDutyEdit')
      },
      // 仓库库存
      {
        path: 'warehouseInventory/list',
        name: `warehousing-warehouseInventoryList`,
        meta: {
          title: '仓库库存',
          access: ['warehousing-warehouseInventoryList']
        },
        component: () => import('@/view/warehouse/warehouseInventory/warehouseInventoryList')
      },
      // 仓库库存 查看
      {
        path: 'warehouseInventory/info/:id?',
        name: `warehousing-warehouseInventoryInfo`,
        meta: {
          title: '仓库库存 查看',
          hideInMenu: true, // 菜单栏不显示
          access: ['warehousing-warehouseInventoryInfo']
        },
        component: () => import('@/view/warehouse/warehouseInventory/warehouseInventoryInfo')
      },
      // 入库管理
      {
        path: 'warehouseInventoryIn/list',
        name: `warehousing-warehouseInventoryInList`,
        meta: {
          title: '入库管理',
          access: ['warehousing-warehouseInventoryInList']
        },
        component: () => import('@/view/warehouse/warehouseInventoryIn/warehouseInventoryInList')
      },
      // 入库单 添加
      {
        path: 'warehouseInventoryIn/edit/:id?',
        name: `warehousing-warehouseInventoryInEdit`,
        meta: {
          title: '入库单 添加/编辑',
          hideInMenu: true, // 菜单栏不显示
          access: ['warehousing-warehouseInventoryInEdit']
        },
        component: () => import('@/view/warehouse/warehouseInventoryIn/warehouseInventoryInEdit')
      },
      // 入库单 查看
      {
        path: 'warehouseInventoryIn/info/:id?',
        name: `warehousing-warehouseInventoryInInfo`,
        meta: {
          title: '入库单 查看',
          hideInMenu: true, // 菜单栏不显示
          access: ['warehousing-warehouseInventoryInInfo']
        },
        component: () => import('@/view/warehouse/warehouseInventoryIn/warehouseInventoryInInfo')
      },
      // 出库管理
      {
        path: 'warehouseInventoryOut/list',
        name: `warehousing-warehouseInventoryOutList`,
        meta: {
          title: '出库管理',
          access: ['warehousing-warehouseInventoryOutList']
        },
        component: () => import('@/view/warehouse/warehouseInventoryOut/warehouseInventoryOutList')
      },
      // 出库单 添加
      {
        path: 'warehouseInventoryOut/edit/:id?',
        name: `warehousing-warehouseInventoryOutEdit`,
        meta: {
          title: '出库单 添加/编辑',
          hideInMenu: true, // 菜单栏不显示
          access: ['warehousing-warehouseInventoryOutEdit']
        },
        component: () => import('@/view/warehouse/warehouseInventoryOut/warehouseInventoryOutEdit')
      },
      // 出库单 查看
      {
        path: 'warehouseInventoryOut/info/:id?',
        name: `warehousing-warehouseInventoryOutInfo`,
        meta: {
          title: '出库单 查看',
          hideInMenu: true, // 菜单栏不显示
          access: ['warehousing-warehouseInventoryOutInfo']
        },
        component: () => import('@/view/warehouse/warehouseInventoryOut/warehouseInventoryOutInfo')
      },
      // 库存盘点
      {
        path: 'warehouseInventoryCheck/list',
        name: `warehousing-warehouseInventoryCheckList`,
        meta: {
          title: '库存盘点',
          access: ['warehousing-warehouseInventoryCheckList']
        },
        component: () => import('@/view/warehouse/warehouseInventoryCheck/warehouseInventoryCheckList')
      },
      // 基地库存存取周期
      {
        path: 'landBaseAverageCycle/list',
        name: `warehousing-landBaseAverageCycle`,
        meta: {
          title: '存取周期',
          access: ['warehousing-landBaseAverageCycle']
        },
        component: () => import('@/view/warehouse/landBaseAverageCycle/landBaseAverageCycleList')
      },

      // 环境设备
      {
        path: 'warehouseDeviceEnvironment/list',
        name: `warehousing-warehouseDeviceEnvironmentList`,
        meta: {
          title: '环境设备',
          access: ['warehousing-warehouseDeviceEnvironmentList']
        },
        component: () => import('@/view/warehouse/warehouseDevice/warehouseDeviceEnvironmentList')
      },
      // 环境设备 历史记录
      {
        path: 'warehouseDeviceEnvironment/log/list/:warehouseId?',
        name: `warehousing-warehouseDeviceEnvironmentLogList`,
        meta: {
          title: '环境设备 历史记录',
          hideInMenu: true, // 菜单栏不显示
          access: ['warehousing-warehouseDeviceEnvironmentLogList']
        },
        component: () => import('@/view/warehouse/warehouseDevice/warehouseDeviceEnvironmentLogList')
      },
      // 监控设备
      {
        path: 'warehouseDeviceMonitoring/list',
        name: `warehousing-warehouseDeviceMonitoringList`,
        meta: {
          title: '监控设备',
          access: ['warehousing-warehouseDeviceMonitoringList']
        },
        component: () => import('@/view/warehouse/warehouseDevice/warehouseDeviceMonitoringList')
      }

    ]
  },

  // 系统设备管理
  {
    path: '/admin/device',
    name: 'device',
    meta: {
      title: '设备预警管理',
      icon: 'ios-cog',
      access: ['device']
    },
    component: Main,
    children: [
      // 设备信息
      {
        path: 'list',
        name: 'device-deviceList',
        meta: {
          title: '基地设备',
          access: ['device-deviceList']
        },
        component: () => import('@/view/device/deviceList')
      },
      // 设备配置
      {
        path: 'thresholds/:id?',
        name: 'device-deviceThresholds',
        meta: {
          title: '设备配置',
          hideInMenu: true, // 菜单栏不显示
          access: ['device-deviceThresholds']
        },
        component: () => import('@/view/device/deviceThresholds')
      },
      // 设备编辑
      {
        path: 'edit/:id?',
        name: 'device-deviceEdit',
        meta: {
          title: '设备编辑',
          hideInMenu: true, // 菜单栏不显示
          access: ['device-deviceEdit']
        },
        component: () => import('@/view/device/deviceEdit')
      },
      // 仓库设备
      {
        path: 'warehouse/list',
        name: 'device-deviceWarehouseList',
        meta: {
          title: '仓库设备',
          access: ['device-deviceWarehouseList']
        },
        component: () => import('@/view/device/deviceWarehouseList')
      },
      // 仓库设备配置
      {
        path: 'warehouse/thresholds/:id?',
        name: 'device-deviceWarehouseThresholds',
        meta: {
          title: '设备配置',
          hideInMenu: true, // 菜单栏不显示
          access: ['device-deviceWarehouseThresholds']
        },
        component: () => import('@/view/device/deviceWarehouseThresholds')
      },
      // 耳标设备
      {
        path: 'tag/list',
        name: 'device-deviceTagList',
        meta: {
          title: '耳标设备',
          access: ['device-deviceTagList']
        },
        component: () => import('@/view/device/tagSetting/tagSettingList')
      },
      // 耳标设备 编辑
      {
        path: 'tag/edit/:id?',
        name: 'device-deviceTagEdit',
        meta: {
          title: '耳标设备 编辑',
          hideInMenu: true // 菜单栏不显示
        },
        component: () => import('@/view/device/tagSetting/tagSettingEdit')
      },

      // 环境设备 历史记录
      {
        path: 'environment/log/list/:deviceSn?',
        name: 'device-environmentLogList',
        meta: {
          title: '环境设备 历史记录',
          hideInMenu: true // 菜单栏不显示
        },
        component: () => import('@/view/device/deviceEnvironmentLogList')
      },
      // 气象设备 历史记录
      {
        path: 'meteorology/log/list/:deviceSn?',
        name: 'device-meteorologyLogList',
        meta: {
          title: '气象设备 历史记录',
          hideInMenu: true // 菜单栏不显示
        },
        component: () => import('@/view/device/deviceMeteorologyLogList')
      }
      // 土壤设备 历史记录
      // 虫情设备 历史记录
      // 苗情设备 历史记录
    ]
  },

  // 交易中心
  {
    path: '/admin/tradingCenter',
    name: `tradingCenter`,
    meta: {
      title: '交易中心管理',
      icon: 'ios-paper'
      // access: ['tradingCenter']
    },
    component: Main,
    children: [
      {
        path: 'shopManagement',
        name: 'tradingCenter-shopManagement',
        meta: {
          title: '店铺管理',
          icon: 'ivu-icon ivu-icon-md-basket'
          // access: ['tradingCenter-shopManagement']
        },
        component: parentView,
        children: [
          // 店铺列表
          {
            path: 'shop/list',
            name: 'tradingCenter-shopManagement-shopList',
            meta: {
              title: '店铺列表'
              // access: ['tradingCenter-shopManagement-shopList']
            },
            component: () => import('@/view/shop/shop/shopList')
          },
          // 店铺 添加/编辑
          {
            path: 'shop/edit/:id?',
            name: 'tradingCenter-shopManagement-shopEdit',
            meta: {
              title: '店铺 添加/编辑',
              hideInMenu: true,
              // access: ['tradingCenter-shopManagement-shopEdit']
            },
            component: () => import('@/view/shop/shop/shopEdit')
          },
          // 店铺详情
          {
            path: 'shop/info/:id',
            name: 'tradingCenter-shopManagement-shopInfo',
            meta: {
              title: '店铺详情',
              hideInMenu: true,
              // access: ['tradingCenter-shopManagement-shopInfo']
            },
            component: () => import('@/view/shop/shop/shopInfo')
          },
          // 提现记录
          {
            path: '/admin/shop/withdraw/list',
            name: 'shopWithdrawList',
            meta: {
              title: '提现记录'
              // access: ['shopWithdrawList']
            },
            component: () => import('@/view/shop/shopWithdraw/shopWithdrawList')
          },
        ]
      },
      // 商品管理
      {
        path: 'goodsManagement',
        name: 'tradingCenter-goodsManagement',
        meta: {
          title: '商品管理',
          icon: 'ivu-icon ivu-icon-md-basket'
          // access: ['tradingCenter-goodsManagement']
        },
        component: parentView,
        children: [
          // 商品列表
          {
            path: 'goods/list',
            name: 'tradingCenter-goodsManagement-goodsList',
            meta: {
              title: '商品列表'
              // access: ['tradingCenter-goodsManagement-goodsList']
            },
            component: () => import('@/view/goods/goods/goodsList')
          },
          // 商品添加/编辑
          {
            path: 'goods/edit/:id?',
            name: 'tradingCenter-goodsManagement-goodsEdit',
            meta: {
              hideInMenu: true,
              title: '商品 添加/编辑'
              // access: ['tradingCenter-goodsManagement-goodsEdit']
            },
            component: () => import('@/view/goods/goods/goodsEdit')
          },
          // 商品查看
          {
            path: 'goods/info/:id?',
            name: 'tradingCenter-goodsManagement-goodsInfo',
            meta: {
              hideInMenu: true,
              title: '商品查看'
              // access: ['tradingCenter-goodsManagement-goodsInfo']
            },
            component: () => import('@/view/goods/goods/goodsInfo')
          },
          {
            path: '/admin/goods/category',
            name: 'categorylist',
            meta: {
              title: '商品分类'
              // access: ['goods-categorylist']
            },
            component: () => import('@/view/goods/category/index')
          },
          // 商品评价
          {
            path: '/admin/goods/comments/list',
            name: 'goodsCommentsList',
            meta: {
              title: '商品评价'
            },
            component: () => import('@/view/goods/goodsComments/goodsCommentsList')
          },
        ]
      },
      {
        path: '/admin/goods/points',
        name: 'goods_points',
        meta: {
          title: '积分商品管理',
          icon: 'ivu-icon ivu-icon-md-basket',
          // access: ['goods-points']
        },
        component: parentView,
        children: [
          {
            path: '/admin/goods/points/list',
            name: 'goods_points_goodslist',
            meta: {
              title: '积分商品列表'
              // access: ['goods-points-goodslist']
            },
            component: () => import('@/view/goods/point_list.vue')
          },
          {
            path: '/admin/goods/points/add/:id?',
            name: 'points_addGoods',
            meta: {
              hideInMenu: true,
              notCache: true,
              title: '添加商品'
              // access: ['goods-points-addGoods']
            },
            component: () => import('@/view/goods/points_goodsEdit.vue')
          }
        ]
      },
      {
        path: '/admin/order',
        name: 'order',
        meta: {
          title: '订单管理',
          icon: 'ios-cart',
          // access: ['order']
        },
        component: parentView,
        children: [
          {
            path: '/admin/order/list',
            name: 'orderList',
            meta: {
              title: '订单列表',
              notCache: true,
              // access: ['order-orderList']
            },
            component: () => import('@/view/order/list')
          },
          {
            path: '/admin/order/detail/:id?',
            name: 'orderDetail',
            meta: {
              title: '订单详情',
              hideInMenu: true,
              notCache: true,
              // access: ['order-orderDetail']
            },
            component: () => import('@/view/order/orderInfo')
          },
          {
            path: '/admin/order/pointlist',
            name: 'pointorderList',
            meta: {
              title: '积分订单列表',
              notCache: true,
              // access: ['order-pointlist']
            },
            component: () => import('@/view/order/pointlist')
          },
          {
            path: '/admin/order/pointdetail/:id?',
            name: 'orderDetail',
            meta: {
              title: '订单详情',
              hideInMenu: true,
              notCache: true,
              // access: ['order-pointdetail']
            },
            component: () => import('@/view/order/PointOrderInfo')
          },
        ]
      },
      // 用户管理
      {
        path: '/admin/user',
        name: 'user',
        meta: {
          title: '用户管理',
          icon: 'ios-people',
          // access: ['user']
        },
        component: parentView,
        children: [
          // 用户列表
          {
            path: '/admin/user/list',
            name: 'userList',
            meta: {
              title: '用户列表',
              notCache: true,
              // access: ['user-userList']
            },
            component: () => import('@/view/user/user/userList')
          },
          // 积分记录
          {
            path: '/admin/user/userIntegralLog/list',
            name: 'userIntegralLogList',
            meta: {
              title: '积分记录',
              notCache: true,
            },
            component: () => import('@/view/user/userIntegralLog/userIntegralLogList')
          },

        ]
      },
      {
        path: '/admin/supply',
        name: 'supply',
        meta: {
          title: '供需管理',
          icon: 'ivu-icon ivu-icon-md-basket'
          // access: ['supply']
        },
        component: parentView,
        children: [
          {
            path: '/admin/supply/list',
            name: 'supplylist',
            meta: {
              title: '供需列表'
              // access: ['goodslist']
            },
            component: () => import('@/view/supply/lists/index')
          },
          {
            path: '/admin/supply/category',
            name: 'supplycategorylist',
            meta: {
              title: '供需分类'
              // access: ['goods-categorylist']
            },
            component: () => import('@/view/supply/category/index')
          },
        ]
      }

    ]
  },

  // 公众咨询管理
  {
    path: '/admin/consult',
    name: 'consult',
    meta: {
      title: '公众咨询管理',
      icon: 'ios-chatbubbles',
      access: ['consult']
    },
    component: Main,
    children: [
      // 商城用户咨询
      {
        path: 'userInformation/list',
        name: 'consult-userInformationList',
        meta: {
          title: '商城用户咨询',
          access: ['consult-userInformationList']
        },
        component: () => import('@/view/user/userInformation/userInformationList')
      },
      // 基地用户咨询
      {
        path: 'adminUserInformation/list',
        name: 'consult-adminUserInformationList',
        meta: {
          title: '基地用户咨询',
          access: ['consult-adminUserInformationList']
        },
        component: () => import('@/view/landBase/adminUserInformation/adminUserInformationList')
      },
      // 专家管理
      {
        path: 'expert/list',
        name: 'consult-expertList',
        meta: {
          title: '专家管理',
          access: ['consult-expertList']
        },
        component: () => import('@/view/expert/expert/expertList')
      },
      // 专家管理 添加/编辑
      {
        path: 'expert/edit/:id?',
        name: 'consult-expertEdit',
        meta: {
          title: '专家管理 添加/编辑',
          hideInMenu: true, // 菜单栏不显示
          access: ['consult-expertEdit']
        },
        component: () => import('@/view/expert/expert/expertEdit')
      },
      // 专家管理 查看
      {
        path: 'expert/info/:id?',
        name: 'consult-expertInfo',
        meta: {
          title: '专家管理 查看',
          hideInMenu: true, // 菜单栏不显示
          access: ['consult-expertInfo']
        },
        component: () => import('@/view/expert/expert/expertInfo')
      }

    ]
  },

  // 系统文章管理
  {
    path: '/admin/articleManagement',
    name: 'articleManagement',
    meta: {
      title: '系统文章管理',
      icon: 'ios-paper',
      access: ['articleManagement']
    },
    component: Main,
    children: [
      // 生产文章管理
      {
        path: 'productionArticle',
        name: 'articleManagement-productionArticle',
        meta: {
          title: '生产文章管理',
          access: ['articleManagement-productionArticle']
        },
        component: parentView,
        children: [
          // 生产文章
          {
            path: 'baseArticle/list',
            name: 'articleManagement-productionArticle-baseArticleList',
            meta: {
              title: '生产文章',
              access: ['articleManagement-productionArticle-baseArticleList']
            },
            component: () => import('@/view/baseArticle/baseArticle/baseArticleList')
          },
          // 生产文章 添加/编辑
          {
            path: 'baseArticle/edit/:id?',
            name: 'articleManagement-productionArticle-baseArticleEdit',
            meta: {
              title: '生产文章 添加/编辑',
              hideInMenu: true, // 菜单栏不显示
              access: ['articleManagement-productionArticle-baseArticleEdit']
            },
            component: () => import('@/view/baseArticle/baseArticle/baseArticleEdit')
          },
          // 生产文章 查看
          {
            path: 'baseArticle/info/:id?',
            name: 'articleManagement-productionArticle-baseArticleInfo',
            meta: {
              title: '生产文章 查看',
              hideInMenu: true, // 菜单栏不显示
              access: ['articleManagement-productionArticle-baseArticleInfo']
            },
            component: () => import('@/view/baseArticle/baseArticle/baseArticleInfo')
          },
          // 文章评论
          {
            path: 'baseArticleComments/list/:id?',
            name: 'articleManagement-productionArticle-baseArticleCommentsList',
            meta: {
              title: '文章评论',
              access: ['articleManagement-productionArticle-baseArticleCommentsList']
            },
            component: () => import('@/view/baseArticle/baseArticleComments/baseArticleCommentsList')
          }
        ]
      },
      // 系统协议管理
      {
        path: 'systemAgreement',
        name: 'articleManagement-systemAgreement',
        meta: {
          title: '系统协议管理',
          access: ['articleManagement-systemAgreement']
        },
        component: parentView,
        children: [
          // 系统协议
          {
            path: 'article/list',
            name: 'articleManagement-systemAgreement-articleList',
            meta: {
              title: '系统协议',
              access: ['articleManagement-systemAgreement-articleList']
            },
            component: () => import('@/view/article/systemAgreementList')
          },
          // 系统协议 添加/编辑
          {
            path: 'article/edit/:id?',
            name: `articleManagement-systemAgreement-articleEdit`,
            meta: {
              title: '系统协议 添加/编辑',
              hideInMenu: true,
              access: ['articleManagement-systemAgreement-articleEdit']
            },
            component: () => import('@/view/article/systemAgreementEdit.vue')
          }
        ]
      },
      // 系统公告管理
      {
        path: 'announcementManagement',
        name: 'articleManagement-announcementManagement',
        meta: {
          title: '系统公告管理',
          access: ['articleManagement-announcementManagement']
        },
        component: parentView,
        children: [
          // 公告列表
          {
            path: 'announcement/list',
            name: 'articleManagement-announcementManagement-announcementList',
            meta: {
              title: '公告列表',
              access: ['articleManagement-announcementManagement-announcementList']
            },
            component: () => import('@/view/article/announcementList')
          },
          // 公告 添加/编辑
          {
            path: 'announcement/edit/:id?',
            name: `articleManagement-announcementManagement-announcementEdit`,
            meta: {
              title: '公告 添加/编辑',
              hideInMenu: true,
              access: ['articleManagement-announcementManagement-announcementEdit']
            },
            component: () => import('@/view/article/announcementEdit')
          }
        ]
      },
    ]
  },

  // 系统报告管理
  {
    path: '/admin/reportManagement',
    name: 'reportManagement',
    meta: {
      title: '系统报告管理',
      icon: 'ios-paper',
      access: ['reportManagement']
    },
    component: Main,
    children: [
      // 系统报告
      {
        path: 'report/list',
        name: 'reportManagement-reportList',
        meta: {
          title: '系统报告',
          access: ['reportManagement-reportList']
        },
        component: () => import('@/view/landBase/landBaseReport/landBaseReportList')
      },
      // 报告模版
      {
        path: 'reportTemplate/list',
        name: 'reportManagement-reportTemplateList',
        meta: {
          title: '报告模版',
          hideInMenu: true, // 菜单栏不显示
          access: ['reportManagement-reportTemplateList']
        },
        component: () => import('@/view/landBase/landBaseReportText/landBaseReportTextList')
      },
      // 报告模版 编辑
      {
        path: 'reportTemplate/edit/:id?',
        name: 'reportManagement-reportTemplateEdit',
        meta: {
          title: '报告模版 编辑',
          hideInMenu: true, // 菜单栏不显示
          access: ['reportManagement-reportTemplateEdit']
        },
        component: () => import('@/view/landBase/landBaseReportText/landBaseReportTextEdit')
      },
      // 商品销售报告
      {
        path: 'goodsSalesReport/list',
        name: 'reportManagement-goodsSalesReportList',
        meta: {
          title: '商品销售报告',
          access: ['reportManagement-goodsSalesReportList']
        },
        component: () => import('@/view/goods/goodsSalesReport/goodsSalesReportList')
      },


    ]
  },

  // 权限管理
  {
    path: '/admin/adminUser',
    name: 'adminUerM',
    meta: {
      title: '权限管理',
      icon: 'ios-lock',
      access: ['adminUerM']
    },
    component: Main,
    children: [
      {
        path: '/admin/admin/userlist',
        name: 'adminUser',
        meta: {
          title: '平台用户',
          access: ['adminUser']
        },
        component: () => import('@/view/admin/userlist')
      },
      {
        path: '/admin/admin/group',
        name: 'adminGroup',
        meta: {
          title: '平台角色',
          access: ['adminGroup']
        },
        component: () => import('@/view/admin/roleList')
      },
      {
        path: '/admin/admin/menu',
        name: 'adminMenu',
        meta: {
          title: '菜单列表'
        },
        component: () => import('@/view/admin/menuList')
      }
    ]
  },

  // 广告管理
  {
    path: '/admin/advert',
    name: 'advert',
    meta: {
      title: '广告管理',
      icon: 'ios-images'
      // access: ['advert']
    },
    component: Main,
    children: [
      {
        path: '/admin/advertPic/group',
        name: 'advertGroup',
        meta: {
          title: '幻灯管理'
          // access: ['advertGroup']
        },
        component: () => import('@/view/advertPic/groupList.vue')
      },
      {
        path: '/admin/advertPic/lb/:id?',
        name: 'advertLb',
        meta: {
          hideInMenu: true,
          notCache: true,
          title: '轮播图列表'
          // access: ['advertLb']
        },
        component: () => import('@/view/advertPic/list2.vue')
      },
      {
        path: '/admin/advert/list',
        name: 'advertList',
        meta: {
          title: '广告列表'
          // access: ['advert-advertList']
        },
        component: () => import('@/view/advertPic/singlePic')
      }
    ]
  },

  // 系统设置
  {
    path: '/admin/systemSetting',
    name: 'systemSetting',
    meta: {
      title: '系统设置',
      icon: 'ios-hammer',
      access: ['system']
    },
    component: Main,
    children: [
      {
        path: '/admin/system/setting',
        name: 'sysSetting',
        meta: {
          title: '基本配置',
          access: ['system-setting']
        },
        component: () => import('@/view/system/setting')
      },
      // 会员等级
      {
        path: 'membershipLevels/list',
        name: 'systemSetting-membershipLevelsList',
        meta: {
          title: '会员等级',
          access: ['system-membershipLevelsList']
        },
        component: () => import('@/view/system/membershipLevels/membershipLevelsList')
      },
      // 会员等级 添加/编辑
      {
        path: 'membershipLevels/edit/:id?',
        name: 'systemSetting-membershipLevelsEdit',
        meta: {
          title: '会员等级 编辑',
          hideInMenu: true, // 菜单栏不显示
          access: ['system-membershipLevelsEdit']
        },
        component: () => import('@/view/system/membershipLevels/membershipLevelsEdit')
      },
      // 系统日志
      {
        path: 'systemLog/list',
        name: 'systemSetting-systemLogList',
        meta: {
          title: '系统日志',
          access: ['system-systemLogList']
        },
        component: () => import('@/view/system/systemLog/systemLogList')
      }
    ]
  },


]

export default defaults
